<template lang="pug">
.engage-wrap
  scene(@open-report-card="openReportCard")
  theme
  .engage(v-if="engage", :class="{ shown: engageShown, 'has-fund': engage.fund, 'has-ticker': engage.ticker }")
    global-events(v-if="engageShown && !chartShown")
    stocks(v-if="engageShown && engage.fund && engage.ticker", :ticker="engage.ticker")
    fund(v-if="engage && engageShown && engage.fund && engage.ticker", :class="{ 'move-left': !engage.ticker }")
    perf(v-if="engage && engageShown && engage.fund && engage.ticker", :class="{ 'move-left': !engage.ticker }")
    //-.make-image(:style="{ position: 'absolute', top: '2rem', left: '71.2rem', 'z-index': '18500', 'background-color': 'lightblue', padding: '1rem', 'border-radius': '0.5rem', border: '2px solid black', cursor: 'pointer', 'font-weight': 500 }", @click="makeImage") make image
    .widget(v-if="engageFundGrowthRate && pubsImages", @click="makeImage", title="click to copy and close", :class="{ hide: hideWidget, landscape: landscapeWidget }")
      .top-items
        .title-spacer
        .fund-spacer
        .logo(v-if="landscapeWidget")
          img(:src="pubsImages[engageBap.id.toLowerCase() + '-logo.jpg']")
        .item.double(v-for="(pub, key) in topPublishersMap", :key="key", :title="key")
          img(:src="pubsImages[key + '-logo.jpg']")
      .title {{ title }}
      fund
      .widget-stats
        .stat
          .label all time growth
          .value {{ engageFundGrowthRate }}
        .stat
          .label top holdings
          .value {{ Object.keys(topPublishersMap).length || '-' }}
        .stat
          .label total holdings
          .value {{ Object.keys(publishers).length || '-' }}
        .stat
          .label new videos
          .value {{ widgetVideoCount }}
        .stat
          .label new documents
          .value {{ widgetDocCount }}
      .items(v-if="!landscapeWidget")
        //-.item(v-for="key in somePubs", :key="key", :title="key")
        //-.item.double(v-for="(pub, key) in topPublishersMap", :key="key", :title="key")
        //-  img(:src="pubsImages[key + '-logo.jpg']")
        .gap
        .logo
          img(:src="pubsImages[engageBap.id.toLowerCase() + '-logo.jpg']")
        .item(v-for="key in Object.keys(publishers).filter(k => !topPublishersMap[k])", :key="key", :title="key")
          img(:src="pubsImages[key + '-logo.jpg']")
          //-.bg(:style="{ 'background-image': `url('${ pubsImages[key + '-logo.jpg'] }` }")
    .banner(:class="{ 'has-viewer': pdf, [engageViewMode]: true, 'has-themes-pubs': engage.banner && engage.banner.themes, 'has-fund': engage.fund }")
      .view-mode
        .a-b(:class="{ on: engageViewMode === 'ab' }", @click="engageViewMode = 'ab'")
        .a-b-c(:class="{ on: engageViewMode === 'abc' }", @click="engageViewMode = 'abc'")
          .v
        .b-c(:class="{ on: engageViewMode === 'bc' }", @click="engageViewMode = 'bc'")
      .key-documents
        .key-document(v-for="{ id, folder, title, pubDate } in (engage.banner.documents || []).filter((item, index) => pdf || index <= (engage.fund && 3 || 7))",
                      @click="pdf = `https://content.weave.ai/documents/${ id }-1.pdf`",
                      :class="{ 'has-pages': filteredPages(id).length, 'two-pages': filteredPages(id).length < 3 }")
          .title {{ title }}
          //-.bg(v-lazy:background-image="`https://content.weave.ai/picture-images/${ id }-1.png`")
          .bg(v-lazy:background-image="`https://d2ks69eyvb68ub.cloudfront.net/api/GetDocProcPdfThumbnail?did=${ id }&page=${ 1 }`")
          .date {{ date(pubDate) | moment('from', 'now') }}
          .pages
            .page(v-for="{ docId: did, page: pg } in filteredPages(id)",
                  @click.stop.prevent.capture="pdf = `https://content.weave.ai/documents/${ did || 'no did' }-${ pg }.pdf`")
              //-.bg(v-lazy:background-image="`https://content.weave.ai/picture-images/${ did }-${ pg }.png`")
              .bg(v-lazy:background-image="`https://d2ks69eyvb68ub.cloudfront.net/api/GetDocProcPdfThumbnail?did=${ id }&page=${ pg }`")
      viewer(v-if="pdf || pdfPending", :toc-pages="tocPages()", :closer="true")
      .themes-pubs
        .themes-section(v-if="engage.banner && engage.banner.themes")
          .filters
            .has has:
            .filter.has-videos(:class="{ on: engageVideosOnly, both: engageVideosOnly && engageTweetsOnly }", @click="engageVideosOnly = !engageVideosOnly") videos
            .filter.has-tweets(:class="{ on: engageTweetsOnly, both: engageVideosOnly && engageTweetsOnly }", @click="engageTweetsOnly = !engageTweetsOnly") tweets
          transition-group.items(:class="{ skinny: pdf && (engageViewMode === 'abc') || engage.fund }", name="themes-flip-list", tag="div")
            .item(v-for="([key, { title, image, cr, genre }], index) in sortedThemes",
                  @click="openTheme(key)",
                  :key="key")
              .tile(:class="{ 'has-polar': aboveMean(key) || hasRisk(key) || aboveOpportunity(key) }")
                .bg(v-lazy:background-image="image")
                //-.title(v-resize-text="{ ratio: 0.5, minFontSize: '7px', maxFontSize: '7px', delay: 500 }") {{ genre }}
                .glare(v-if="aboveMean(key)", :class="{ on: glareKey === key }")
                .polar(v-if="aboveMean(key) || hasRisk(key) || aboveOpportunity(key)",
                       :title="[hasOpportunity(key) && 'opportunity' || '', hasInsights(key) && 'insights' || '', hasRisk(key) && 'risk' || ''].join(', ').trim().replace(/,,/g, ',').replace(/^,\\s|,$/g, '')")
                  .wedge
                    svg(:style="{ opacity: aboveOpportunity(key) && 1 || hasOpportunity(key) && 0.5 || 0 }",
                        height="16",
                        width="16",
                        viewBox="0 0 16 16")
                      //circle(r="10" cx="10" cy="10" fill="white")
                      circle(r="5" cx="8" cy="8",
                             fill="transparent",
                             stroke="#8d6e4f",
                             stroke-width="10",
                             stroke-dasharray="3 30",
                             transform="rotate(-90) translate(-20)")
                  .wedge
                    svg(:style="{ opacity: aboveInsights(key) && 1 || hasInsights(key) && 0.5 || 0 }",
                        height="16",
                        width="16",
                        viewBox="0 0 16 16")
                      circle(r="5" cx="8" cy="8",
                             fill="transparent",
                             stroke="#8d6e4f",
                             stroke-width="10",
                             stroke-dasharray="3 30",
                             transform="rotate(-90) translate(-20)")
                  .wedge
                    svg(:style="{ opacity: aboveRisk(key) && 1 || hasRisk(key) && 0.5 || 0 }",
                        height="16",
                        width="16",
                        viewBox="0 0 16 16")
                      circle(r="5" cx="8" cy="8",
                             fill="transparent",
                             stroke="#8d6e4f",
                             stroke-width="10",
                             stroke-dasharray="3 30",
                             transform="rotate(-90) translate(-20)")
                .title(:style="{ 'font-size': '0.8rem', 'text-align': 'center' }") {{ genre }}
              .title {{ title }}
        .publishers-section(v-if="engage.fund")
          .publishers(:class="{ skinny: engage.banner && engage.banner.themes }")
            .publisher(v-for="(pub, key) in publishers",
                       @click.stop.prevent.capture="engagePub = key; engagePubContext = publishers",
                       :key="key",
                       :title="`open ${ pub.n }`")
              .bg(v-lazy:background-image="`https://content.weave.ai/picture-images/${ key }-logo.jpg`")
      .publisher
        .bg(v-lazy:background-image="`https://content.weave.ai/picture-images/${ engage.publisher.key }-logo.jpg`")
  report-card(v-if="reportCardReady", :class="{ shown: engageReportCardShown }")
  .sections-wrap(:class="{ hide: pdf }")
    .sections(:class="{ 'has-selection': engageSelectedSection }", :style="{ 'grid-template-columns': `repeat(${ Math.min((engage && engage.sections || []).length, 6) }, 1fr)` }")
      .section(v-for="{ title, subsections } in engage && engage.sections || []",
               @click="engageSelectedSection = engageSelectedSection !== title && title || null",
               :class="{ selected: engageSelectedSection === title }") {{ title }}
        report-opener.for-documents(:class="{ on: (subsections || []).map(({ primaryType: pt }) => pt).includes('Insights') }")
        .for-videos(:class="{ on: (subsections || []).map(({ primaryType: pt }) => pt).includes('Videos') }")
  .section-viewer-wrap(:class="{ shown: engageSelectedSection }")
    .section-viewer(:class="{ 'pdf-mode': pdf || pdfPending }")
      .title(:class="{ left: engageSection.videos.items.length }") {{ engageSection.title }}
      .widgets(:class="{ 'has-videos': engageSection.videos.items.length, 'has-insights': engageSection.insights.length }")
        .insights-documents(:class="{ 'wider-insights': widerInsights }")
          .themes-section(v-if="!pdf && !pdfPending && !hasThemes(engageSection)", :style="engageSection.earningInsights.publishers && {} || { 'border-bottom-width': 0 }")
            .title themes
            .themes
              //.selected-themes.theme
              //  .theme(v-for="(_, title) in engageSelectedThemes",
              //    :title="title",
              //    @click="toggleEngageSelectedTheme(title)",
              //    :class="{ selected: engageSelectedThemes[title] }")
              //    .bg(:style="themes[title] && { 'background-image': `url('${ themes[title].image }')` } || {}") {{ themes[title] }}
              .theme(v-for="{ title, image } in themes",
                     :title="title",
                     @click="toggleEngageSelectedTheme(title)",
                     :class="{ selected: engageSelectedThemes[title] }")
                .title {{ title.replace(/\sthemes$/, '') }}
                .bg(:style="{ 'background-image': `url('${ image }')` }")
          .insights(:class="{ 'has-filters': showFilters }")
            .max-age(v-if="showFilters", @click="engageMaxAge = engageNextMaxAge") {{ engageMaxAge }}
              .max-ages
                .age(v-for="(ma, index) in engageMaxAges",
                      :title="ma",
                      @click.stop.prevent.capture="engageMaxAge = ma",
                      :class="{ on: ma === engageMaxAge }",
                      :style="{ width: `${ engageMaxAgeNumber(ma) / 1825 * 100 }%`, 'z-index': 8 - index }")
            .filter
              label
                input(placeholder="filter", v-model="engageKeywords")
              .close(v-if="engageKeywords && engageKeywords.trim().length", @click="engageKeywords = ''") &times;
              .toggles
                .risk(@click="engageInsightsCategory = engageInsightsCategory !== 'risk' && 'risk' || null",
                      :title="`show ${ engageInsightsCategory === 'risk' && 'all' || 'only risks' }`",
                      :class="{ on: engageInsightsCategory === 'risk' }") risk
                .opportunity(@click="engageInsightsCategory = engageInsightsCategory !== 'opportunity' && 'opportunity' || null",
                             :title="`show ${ engageInsightsCategory === 'opportunity' && 'all' || 'only opportunities' }`",
                             :class="{ on: engageInsightsCategory === 'opportunity' }") opportunity
            .doc-types(:class="{ shown: showFilters, 'has-selection': Object.keys(selectedWatchlistDocTypes || {}).length }",
                       :count="Object.keys(selectedWatchlistDocTypes || {}).length")
              .doc-type(v-for="(title, key) in docTypes || { wt: 'Webcast transcripts', ect: 'Earnings call transcripts' }",
                        :key="key",
                        :title="title",
                        @click="toggleSelectedWatchlistDocType(key)",
                        :class="{ on: docTypeSelected(key) }") {{ title }}
            .title {{ engageSection.docInsights.title || 'talking points' }}
            .wider-toggle
              .skinny(@click="widerInsights = false", title="single column")
                .bar
                .bar
                .bar
              .wide(@click="widerInsights = true", title="two columns")
                .bar
                .bar
                .bar
            //-transition-group.scroll-wrap(v-if="engageRoboReport && filteredInsights(engageRoboReport.insights || []).length", name="talking-flip", tag="div")
            div.scroll-wrap(v-if="engageRoboReport && filteredInsights(engageRoboReport.insights || []).length")
              a.item-wrap(v-for="({ k, pg, did, fn, pu, md, pgc, kw, id }, index) in engageRoboReport && filteredInsights(engageRoboReport.insights || []) || []",
                          :key="`id || ${ did }|${ pg }|${ k }`"
                          target="_blank",
                          NOThref="`/?f=${ fn };did=${ did };pg=${ pg }`",
                          @click="insightClicked(['section viewer', engageSelectedSection, id || `${ did }|${ pg }|${ k }`]); pdfPending = true; pdf = null; setTimeout(() => { pdf = `https://content.weave.ai/documents/${ did }${ (pgc > 1) && ('-' + pg) || '' }.pdf`; pdfPending = false; engageTocPageCount = pgc; }, 10)",
                          :title="`Open page ${ pg } in viewer`")
                //-.item(v-observe-visibility="{ once: true, callback: isVisible => isVisible && (textVisible[`${ did }|${ pg }|${ k }`] = true) }")
                .item
                  .publisher(@click.stop.prevent.capture="itemPubClick(pu)", :title="publishers[pu] && `filter by ${ publishers[pu].n }` || ''")
                    .bg(v-lazy:background-image="`https://content.weave.ai/picture-images/${ pu }-logo.jpg`")
                    //.bg(:v-lazy-background-image="`https://content.weave.ai/picture-images/${ pu }-logo.jpg`" :style="{ 'background-image': `url('https://content.weave.ai/picture-images/${ pu }-logo.jpg')` }")
                  .date  {{ date(md) | moment('from', 'now') }}
                  .document
                    .bg(v-lazy:background-image="`https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ did }-1.png`")
                  //-.text(v-if="textVisible[`${ did }|${ pg }|${ k }`] && keywords && keywords.length")
                  .text(v-if="engageKeywords || (kw && kw.length)", h="true")
                    highlighter(:text-to-highlight="k",
                                :case-sensitive="false",
                                highlight-class-name="keyword",
                                highlight-tag="span",
                                NOTclick="toPDF({ folderName: fn, id: did, pg })",
                                :search-words="(engageKeywords && engageKeywords.split(/\\s/) || []).concat(kw && kw.length && kw.split(/\\|/g) || [])")
                  .text(v-else is-else="ok") {{ k }}
                  //.text {{ k }}
                  clipboard(:id="id ||`ic|${ did }|${ pg }|${ index }`",
                            :text="k",
                            :url="`/?f=${ fn };did=${ did };pg=${ pg }`",
                            :date="date(md) | moment('MMM Do, YYYY')",
                            :pub="(publishers[pu] || engage.publisher || {}).n || ''",
                            :index="index")
            .no-results(v-else) no results
          viewer(v-if="pdf || pdfPending", :toc-pages="tocPages()", :closer="true", keep-alive)
          .insights-publishers(v-if="engageSection.earningInsights.publishers",
                               :class="{ 'has-selection': Object.keys(engageSelectedPublishers || {}).length, 'show-badges': engageShowPubBadges }")
            .pub-filters(@mouseenter="engageShowPubBadges = true", @mouseleave="leaveFilters", key="pub-filters")
              //.percent-of-fund {{ engage.subsections[engageSection.earningInsights.id].fundPercentageInSubsection.toFixed(2) }}% of fund
              .percent-of-fund
                vc-donut(:sections="[{ value: fundPercentage, color: brn + '77'  }]",
                  title="percentage of fund",
                  :thickness="10",
                  :size="63",
                  foreground="#f6f6f6")
                  .center {{ Math.floor(fundPercentage) }}
                    span.decimals {{ (fundPercentage - Math.floor(fundPercentage)).toFixed(2).replace(/^0/, '').replace(/\.?0?0$/, '') }}%
              .sectors-filters-section(:class="{ 'has-selection': Object.keys(engageSelectedSectors).length }")
                .sector(v-for="(percent, sector) in stats.sectorPercentages",
                        @click="({ shiftKey }) => percent && toggleSector(sector, shiftKey) || (() => true)",
                        :class="{ selected: engageSelectedSectors[sector], 'has-value': percent }",
                        :style="{ height: `${ percent * 0.6 }%` }")
                  .info
                    span.percent {{ percent }}%&nbsp;
                    | &mdash; {{ sector }}
              .regions
                .region(v-for="(region, code) in engageRegions",
                        :class="{ 'has-value': stats && stats.regionPercentages[region], [code]: true, selected: engageSelectedRegions[region] }",
                        @click="({ shiftKey }) => stats && stats.regionPercentages[region] && toggleRegion(region, shiftKey) || (() => true)",
                        :title="region") {{ code }}
              .is-new(@click="engageNewOnly = !engageNewOnly", :class="{ on: engageNewOnly }") new
              .pays(@click="dividendOnly = !dividendOnly", :class="{ on: dividendOnly }") $
              styles
            transition-group.selected-insights-publishers(name="selected-pub-flip", tag="div")
              .insights-publisher.selected(v-for="{ id, n } in selectedPublishers",
                                           @click="toggleEngageSelectedPublisher(id)",
                                           :key="id + '-selected'",
                                           :title="n")
                .bg(v-lazy:background-image="`https://content.weave.ai/picture-images/${ id }-logo.jpg`")
            //-.insights-publisher(v-for="{ id, n } in engageSection.earningInsights.publishers",
            transition-group(name="pub-flip")
              .insights-publisher(v-for="{ id, n } in engageFilteredPublishers",
                                  :class="{ selected: engageSelectedPublishers[id], big: true || engageSection.earningInsights.publishers.length <= 35 }",
                                  @click="toggleEngageSelectedPublisher(id)",
                                  @click.shift.stop.capture="engagePub = id; engagePubContext = 'engageFilteredPublishers'",
                                  @onmouseenter="clearBadgeTimer",
                                  :title="n",
                                  :key="id",
                                  :size="capStyle(id).size",
                                  :kind="capStyle(id).kind")
                .badges(@mouseenter="badgeEnter", @mouseleave="leaveFilters")
                  .is-new(:class="{ on: isNew(id) }") new
                  .cap-style(:title="`${ capStyle(id).size } cap ${ capStyle(id).kind }`", @click.stop.prevent.capture="styleFilter = !styleFilter && Object.values(capStyle(id)).join('|') || null")
                  .pays(:class="{ on: pays(id) }", @click="dividendOnly = !dividendOnly") $
                  .region(:title="region(id).region") {{ region(id).code }}
                  .percentage(:title="`${ percentage(id) } of total fund`") {{ percentage(id) }}
                .bg(v-lazy:background-image="`https://content.weave.ai/picture-images/${ id }-logo.jpg`")
          .themes-full-section(v-else-if="hasThemes(engageSection)")
            //-.filters
            //-  .has-videos has videos
            .selected-themes(:class="{ 'nudge-right': Object.keys(engageSelectedThemes).length > 1 }")
              .selected-theme(v-for="{ title, image, cr, genre, key } in Object.keys(engageSelectedThemes).map(k => ({ key: k, ...(engage.themesMetadata.themes[k] || {} ) }))",
                              @click="toggleEngageSelectedTheme(key)",
                              :key="key",
                              :title="`deselect ${ genre }`")
                .bg(v-lazy:background-image="image")
              .and-or(@click.stop="toggleAndOr()",
                      :title="`switch to ${ andOr === 'and' && 'or' || 'and' }`") {{ andOr }}
                      //-:title="`switch to ${ andOr === 'and' && 'or' || andOr === 'or' && 'nor' || 'and' }`") {{ andOr }}
            .filter
              label
                input(placeholder="filter", v-model="engageThemesKeywords")
              .close(v-if="engageThemesKeywords && engageThemesKeywords.trim().length", @click="engageThemesKeywords = ''") &times;
              .filter-toggle(:title="(sectionThemesParentsOnly || sectionThemesParentFilter) && 'show all' || `only show parent themes`",
                             :class="{ selected: sectionThemesParentsOnly || sectionThemesParentFilter }",
                             @click.stop.capture="topFilterToggle")
                .parent(:class="{ shown: sectionThemesParentFilter }") {{ (filteredFullThemes[sectionThemesParentFilter] || {}).genre || '' }}

            transition-group.items(name="theme-tile-flip", :class="{ 'show-wedges': showWedges }")
              .item(v-for="[key, { title, image, cr, genre, cth }] in Object.entries(filteredFullThemes).sort((a, b) => (b[1].cr || 0) - (a[1].cr || 0))",
                    @click.prevent.stop="({ shiftKey }) => shiftKey ? openTheme(key) : toggleEngageSelectedTheme(key)",
                    :title="genre",
                    :class="{ selected: engageSelectedThemes[key] }"
                    :key="key")
                .tile(:class="{ 'has-polar': aboveMean(key) || hasRisk(key) || aboveOpportunity(key) }")
                  .bg(v-lazy:background-image="image")
                    .glare(v-if="aboveMean(key)", :class="{ on: glareKey === key }")
                  //.title(v-resize-text="{ ratio: 0.5, minFontSize: '7px', maxFontSize: '7px', delay: 500 }") {{ genre }}
                  .filter-toggle(v-if="!!cth",
                                 :title="sectionThemesParentFilter === key && 'show all' || `only show ${ title }`",
                                 :class="{ selected: sectionThemesParentFilter === key }",
                                 @click.prevent.stop.capture="sectionThemesParentFilter = sectionThemesParentFilter !== key && key || ''")
                  .polar(v-if="rank(key) && aboveMean(key) || hasRisk(key) || aboveOpportunity(key) || (sectionThemesParentFilter && (hasOpportunity(key) || hasInsights(key)))",
                         @click.prevent.stop.capture="openTheme(key)",
                         @mouseenter="polarEnter",
                         @mouseleave="polarLeave",
                         :title="`click to open ${ genre } in viewer - ` + [hasOpportunity(key) && 'opportunity' || '', hasInsights(key) && 'insights' || '', hasRisk(key) && 'risk' || ''].join(', ').trim().replace(/,,/g, ',').replace(/^,\\s|,$/g, '')")
                    .border
                    .wedge
                      svg(:style="{ opacity: aboveOpportunity(key) && 1 || hasOpportunity(key) && 0.5 || 0 }",
                          height="16",
                          width="16",
                          viewBox="0 0 16 16")
                        circle(r="5" cx="8" cy="8",
                          fill="transparent",
                          stroke="#8d6e4f",
                          stroke-width="10",
                          stroke-dasharray="2.3 30",
                          transform="rotate(-90) translate(-20)")
                    .wedge
                      svg(:style="{ opacity: aboveInsights(key) && 1 || hasInsights(key) && 0.5 || 0 }",
                          height="16",
                          width="16",
                          viewBox="0 0 16 16")
                        circle(r="5" cx="8" cy="8",
                          fill="transparent",
                          stroke="#8d6e4f",
                          stroke-width="10",
                          stroke-dasharray="2.3 30",
                          transform="rotate(-90) translate(-20)")
                    .wedge
                      svg(:style="{ opacity: aboveRisk(key) && 1 || hasRisk(key) && 0.5 || 0 }",
                          height="16",
                          width="16",
                          viewBox="0 0 16 16")
                        circle(r="5" cx="8" cy="8",
                               fill="transparent",
                               stroke="#8d6e4f",
                               stroke-width="10",
                               stroke-dasharray="2.3 30",
                               transform="rotate(-90) translate(-20)")
                    .rings(:class="{ hide: !rank(key) }")
                      .ring(:class="{ on: rank(key) >= 80 }")
                        .ring(:class="{ on: rank(key) >= 60 }")
                          .ring(:class="{ on: rank(key) >= 40 }")
                            .ring(:class="{ on: rank(key) >= 20 }")
                              .ring.on
                  .legends
                    .legend.opportunity-legend(v-if="hasOpportunity(key)")
                      .legend-title {{ aboveOpportunity(key) && 'strong' || 'has' }} opportunity
                    .legend.insights-legend(v-if="hasInsights(key)")
                      .legend-title has insights
                    .legend.risk-legend(v-if="hasRisk(key)")
                      .legend-title {{ aboveRisk(key) && 'strong' || 'has' }} risk
                  .title(:style="{ 'font-size': '0.8rem', 'text-align': 'center' }") {{ genre }}
                //-.title {{ title }}
          .documents(v-else, :class="{ 'has-selection': Object.keys(engageSelectedDocuments).length }")
            .document(v-for="{ id, title, pubDate } in docs(engageSection) || []",
                      NOTmousemove="zoomDoc",
                      :id="id",
                      :bg="`https://d2ks69eyvb68ub.cloudfront.net/api/GetDocProcPdfThumbnail?did=${ id }&page=${ 1 }`",
                      @click="toggleEngageSelectedDocument(id)",
                      :class="{ selected: engageSelectedDocuments[id] }")
              .title {{ title }}
              //-.bg(v-lazy:background-image="`https://content.weave.ai/picture-images/${ id }-1.png`")
              .bg(v-lazy:background-image="`https://d2ks69eyvb68ub.cloudfront.net/api/GetDocProcPdfThumbnail?did=${ id }&page=${ 1 }`")
              .date {{ date(pubDate) | moment('from', 'now') }}
              .magnifying-glass(@mouseenter="zoomDoc")
        .videos(:style="{ 'grid-template-rows': `repeat(${ engageSection.videos.items.length }, 13rem)` }")
          .title {{ engageSection.videos.title }}
          a.video(v-for="({ id, t, d, pa, ct, u, du, ce }, index) in engageSection.videos.items",
                  :class="{ playing: currentVideo && currentVideo.id === id, 'no-embed': !ce }",
                  :id="`v|${ id }`",
                  @click.stop="playVid(engageSection.videos.items, index)",
                  NOThref="!ce && `https://www.youtube.com/watch?v=${ id }` || null"
                  :target="!ce && '_blank' || null")
            //-.bg(:id="id", v-lazy:background-image="`https://i.ytimg.com/vi/${ id }/mqdefault.jpg')`")
            .bg(:id="id", :style="{ 'background-image': `url('https://i.ytimg.com/vi/${ id }/mqdefault.jpg')` }")
              .duration {{ Math.floor(du / 60) }}:{{ (du % 60 + '0').replace(/^(\d\d)\d/, '$1') }}
              .source(v-if="u", :style="{ 'background-image': u && `url('${ u }')` || '' }", :title="ct")
            .info
              .bap(:title="`Play ${ t }`")
              .source(v-if="u", :style="{ 'background-image': u && `url('${ u }')` || '' }", :title="ct")
              .details
                .title {{ t }}
                .description {{ d }}
                .date(v-if="pa") {{ date(pa) | moment('from', 'now') }}
                .duration {{ Math.floor(du / 60) }}:{{ (du % 60 + '0').replace(/^(\d\d)\d/, '$1') }}
  .exit-sections-wrapper(v-if="engage.exitSections", :class="{ shown: engageLinksShown }")
    .close(@click="engageLinksShown = false") &times;
    global-events(@keyup.esc="engageLinksShown = false")
    .exit-sections(v-for="{ title: sectionTitle, subsections } in engage.exitSections")
      .sub-section(v-for="{ title, secondaryTypes, webLinks: links } in subsections")
        .title {{ sectionTitle }} &mdash; {{ title }}
        a.link(:href="url || ''",
               @click="engageExitClicked([t, url])",
               :class="{ people: secondaryTypes.includes('People'), organization: secondaryTypes.includes('Organization') }",
               v-for="{ title: t, image: u, subTitles: titles = [], url } in links",
               target="_blank")
          .bg(:style="u && { 'background-image': `url('${ u }')` } || {}")
          .title {{ t }}
          .titles
            .tag(v-for="title in titles") {{ title }}
      //-.web-links
    //-.items
    //-  .item(v-for="({ pub: { thumbnail, name } }, key) in engage",
    //-        :key="key",
    //-        :key1="key",
    //-        :title="`open ${ name }`",
    //-        @click.prevent.stop.capture="({ shiftKey }) => shiftKey && '' || loadRobo(key, shiftKey, name)",
    //-        @mouseenter.once="preLoadRobo(key)",
    //-        @mousemove="hoverPub !== key && (hoverPub = key)",
    //-        @mouseleave="hoverPub = null",
    //-        :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
    //-        .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
    //.opener(@click="roboWeaveShown = true") &raquo;
    //-.close(@click="toggleSkimmer")
    //-notifications
</template>
<script>
let shiftTimer;
let recentShift;
let zoomTimer;
let badgeTimer;
let badgeEnterTimer;
let glareTimer;
let showWedgesTimer;
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
import reportCard from './report-card';
import reportOpener from '@/components/report-opener';
import clipboard from '@/components/clipboard';
import highlighter from 'vue-highlight-words';
// import vue2Img from 'vue-2-img';
// import 'vue-2-img/dist/vue-2-img.css';
import html2canvas from 'html2canvas';
export default {
  name: 'engage',
  data() {
    return {
      hoverPub: null,
      wlContext: null,
      reportCardReady: false,
      pubsImages: null,
      hideWidget: false,
      landscapeWidget: false,
      glareKey: null,
      showWedges: false
    };
  },
  watch: {
    async engageFundGrowthRate(newValue) {
      const { publishers, engageBap, pubsImages } = this;
      if (newValue && !pubsImages && /[\;\&]\bswl?\b$/.test(location.href)) {
        const url = 'https://b64.qrl.sh/api/?id=' + [...Object.keys(publishers), engageBap.id.toLowerCase()].map(k => k + '-logo.jpg').join('|');
        const response = await fetch(url);
        if (response.ok) {
          const json = await response.json();
          window.pi = json;
          this.pubsImages = json;
        }
        this.landscapeWidget = /[\;\&]\bswl\b$/.test(location.href);
      }
    },
    async engagePub(newValue) {
      const { engage, fetchReportCard } = this;
      console.log('engagePub watcher fetching report card wl????', engage.scenes[newValue]);
      const { reportCards } = engage.scenes[newValue] || {};
      if (reportCards) {
        console.log('fetching report card wl');
        fetchReportCard({ reportCard: reportCards[0], id: newValue });
      }
    },
    async engageBap({ reportCard, id }) {
      /*{
        id: 'ford',
        n: 'Ford',
        t: [
          'F'
        ],
        reportCard: {
          watchList: 'Weave-Automotive-Watchlist',
          publisherId: 'ford'
        }
      }*/
      this.fetchReportCard({ reportCard, id });
      console.log('engageBap watcher engage');
      return;
      //todo: refactor this to allow launching the report card from scene
      // console.log('watch engageBap', reportCard);
      const wl = (this.wlContext = reportCard?.watchList);
      // this.reportCardReady = false;
      if (wl) {
        this.reportCardReady = false;
        // todo: caching
        await this.$store.dispatch('loadWatchlistLite', wl);
        await (this.watchlistThemesRefPub = id);
        await (this.watchlistThemesParentFilter = 'ESG themes');
        this.reportCardReady = true;
      }
    },
    async engageSelectedSection(newValue, oldValue) {
      if (oldValue) {
        await (this.engageLastSelectedSection = oldValue);
      }
    },
    async engageSection(newValue, oldValue) {
      // if (newValue?.insights || newValue?.docInsights) {
      // await (this.engageRoboReport = null);
      const { engageLastSelectedSection: ls, engageSelectedSection: ns } = this;
      console.log('engageSection watcher', ns, (ls !== ns), ls, (newValue !== oldValue));
      if (ns && (ls !== ns) && (newValue !== oldValue)) {
        console.log('clearing engage selection');
        await (this.engageSelectedDocuments = {});
        await (this.engageSelectedPublishers = {});
        await (this.folderZoomedDoc = {});
      }
      // console.log('engageSection watcher2', newValue, newValue?.themesInsights?.themes);
      if (newValue?.docInsights?.documents || newValue?.earningInsights?.publishers || newValue?.themesInsights?.themes) {
        this.loadEngageRoboReport();
        console.log('watcher loadEngageRoboReport');
      } else {
        this.engageRoboReport = null;
        console.log('watcher engageRoboReport set to null');
      }
    },
    //todo: make these a method call
    async engageSelectedDocuments() {
      if (this.engageSection?.docInsights?.documents) {
        this.loadEngageRoboReport();
      }
    },
    async engageSelectedPublishers() {
      if (this.engageSection?.earningInsights?.publishers) {
        this.loadEngageRoboReport();
      }
    },
    async engageSelectedThemes() {
      // if (this.engageSection?.earningInsights?.publishers) {
      this.loadEngageRoboReport();
      // }
    },
    // async engageKeywords() {
    //   //console.log('engageKeywords watcher');
    //   // if (this.engageSection?.earningInsights?.publishers) {
    //   //this.loadEngageRoboReport();
    //   // }
    // },
    async selectedWatchlistDocTypes() {
      console.log('watch selectedWatchlistDocTypes', this.showFilters);
      if (this.showFilters) {
        this.loadEngageRoboReport();
      }
    },
    async engageOnlyLastQuarter() {
      this.loadEngageRoboReport();
    },
    async engageMaxAge() {
      this.loadEngageRoboReport();
    },
    async engageInsightsCategory() {
      this.loadEngageRoboReport();
    },
    async engageAndOr() {
      this.loadEngageRoboReport();
    }
  },
  computed: {
    //...mapGetters(['customThemes', 'selectedThemes', 'documentsSort', 'skimmerSort', 'themes', 'robo', 'folderLiteCache', 'analytics', 'chartShown', 'hoverTheme']),
    ...mapGetters(['engage', 'publishers', 'refPubInfo', 'engageSection', 'selectedWatchlistDocTypes', 'engageSelectedThemes', 'engageMaxAges', 'pdfPending', 'engageFilteredPublishers', 'engageRegions', 'title', 'engageFundGrowthRate', 'player', 'spotlight', 'spotlightSource']),
    ...vuexComputed(
      'chartShown',
      'roboReportShown',
      // 'engageThemesShown',
      'engageShown',
      'pdf',
      'pdfPending',
      'engageBap',
      'engageViewMode',
      'engageReportCardShown',
      'watchlistThemesParentFilter',
      'watchlistThemesRefPub',
      'currentVideo',
      'collapsed',
      'engageRoboReport',
      'engageSelectedSection',
      'engageSelectedDocuments',
      'engageSelectedPublishers',
      'engageOnlyLastQuarter',
      'engageMaxAge',
      'engageNextMaxAge',
      'engageTocPageCount',
      'engageKeywords',
      'engageLinksShown',
      'folderZoomedDoc',
      'playlist',
      'styleFilter',
      'engageShowPubBadges',
      'dividendOnly',
      'engageNewOnly',
      'engageSelectedRegions',
      'engageSelectedSectors',
      'engagePub',
      'engagePubContext',
      'engageBap',
      'engageTheme',
      'engageVideosOnly',
      'engageTweetsOnly',
      'widerInsights',
      'engageInsightsCategory',
      'engageThemesKeywords',
      'sectionThemesParentFilter',
      'sectionThemesParentsOnly',
      'engageAndOr'
      // 'refPubInfoShown',
      // 'engageThemesParentFilter',
      // 'selectedWatchlistThemes',
      // 'roboReportLaunchedFromWatchList'
    ),
    brn: () => '#8D6E4F',
    stats() {
      return this.engage?.fund?.statistics;
    },
    andOr: {
      get() {
        return this.engageAndOr;
      },
      set(value) {
        this.engageAndOr = value;
      }
    },
    showFilters() {
      const { engageSection } = this;
      return engageSection && !engageSection.subsections?.some(s => s.sourceType === 'Documents');
    },
    docTypes() {
      return this.engageSection?.subsections?.find(({ docTypes }) => docTypes)?.docTypes;
    },
    widgetVideoCount() {
      return Object.keys(this.engage?.notifications?.pubVideos?.itemToSubsectionIds || {})?.length || 0;
    },
    widgetDocCount() {
      return Object.keys(this.engage?.notifications?.documents?.itemToSubsectionIds || {})?.length || 0;
    },
    topPublishersMap() {
      return this.engage.sections
        .find(({ title }) => title === 'Top Holdings')
        .subsections.find(({ publisherIds: pi }) => pi)
        .publisherIds.reduce((all, k) => {
          all[k] = true;
          return all;
        }, {});
    },
    selectedPublishers() {
      const { engageSection, engageSelectedPublishers } = this;
      return engageSection.earningInsights.publishers?.filter(({ id }) => engageSelectedPublishers[id]);
    },
    hoverPubs() {
      const { hoverPub, engage } = this;
      const r = {};
      if (hoverPub) {
        const pubs = Object.keys(engage);
        const index = pubs.indexOf(hoverPub);
        const before = pubs[index - 1];
        if (before) {
          r.before = before;
        }
        const after = pubs[index + 1];
        if (after) {
          r.after = after;
        }
      }
      return r;
    },
    themes() {
      const {
        engageSection: { earningInsights: ei, docInsights: di },
        engage: { themesMetadata: { themes: tmd } }
      } = this;
      //console.log('themes tmd', tmd, di);
      console.log(('themes computed', ei?.themes || di?.themes || []).map(n => tmd[n]));
      return (ei?.themes || di?.themes || []).map(n => tmd[n]);
    },
    sortedThemes() {
      const { engage, hasVideos, engageVideosOnly, hasTweets, engageTweetsOnly } = this;
      //console.log('sortedThemes', Object.entries(engage.themesMetadata.themes).sort((a, b) => (b[1].cr || 0) - (a[1].cr || 0)).map(([k]) => hasVideos(k)));
      return Object.entries(engage.themesMetadata.themes).sort((a, b) => (b[1].cr || 0) - (a[1].cr || 0)).filter(([k]) => engage.banner.themes?.[k] && (!engageVideosOnly || hasVideos(k)) && (!engageTweetsOnly || hasTweets(k)));
    },
    filteredFullThemes() {
      const { engage, engageThemesKeywords, sectionThemesParentsOnly, sectionThemesParentFilter } = this;
      const ts = engage.themesMetadata.themes;
      return (
        ((engageThemesKeywords || sectionThemesParentsOnly || sectionThemesParentFilter) &&
          Object.entries(ts)
            .filter(([key, theme]) => {
              // console.log('filterInsights is filtering');
              // console.log('filteredFullThemes', theme, theme.k, theme.cth);
              const { cth } = theme;
              const k = theme.k || (cth.map(t => ts[t].k).join('|') + `|${ theme.genre }`);
              return (
                (!sectionThemesParentFilter || isChild(key) || sectionThemesParentFilter === key) &&
                (cth || !sectionThemesParentsOnly || sectionThemesParentFilter) &&
                (!engageThemesKeywords || engageThemesKeywords.split(/\s+/).every(testWord))
              );
              function testWord(word) {
                const tester = new RegExp(escapeRegExp(word?.toLowerCase()), 'i');
                return tester.test((k || '').toLowerCase());
              }
              function escapeRegExp(s) {
                return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`; // $& means the whole matched string
              }
              function isChild(key) {
                const parent = ts[sectionThemesParentFilter];
                return parent?.cth?.includes(key);
              }
            })
            .reduce(entriesToObject, {})) ||
        ts
      );
      function entriesToObject(all, [tag, count]) {
        all[tag] = count;
        return all;
      }
    },
    items() {
      const { selectedThemes, customThemes, folderList, skimmerSort } = this;
      const selectedThemesKeys = Object.keys(selectedThemes || {});
      const { length } = selectedThemesKeys;
      return filter();
      function filter() {
        // console.log('items filter 2', (Object.entries(folderList) || []).filter(([did, { th, tg }]) => !length || hasThemes(selectedThemes, th, customThemes, tg))
        //     .reduce((all, [did, doc]) => {
        //       all[did] = doc;
        //       return all;
        //     }, {}));
        //return (Object.entries(folderList) || []).filter(([did, { th, tg }]) => !length || hasThemes(selectedThemes, th, customThemes, tg))
        const sorters = (length && {
          Weight: (a, b) => totalWeights(b[1], 'w') - totalWeights(a[1], 'w'),
          vis: (a, b) => totalWeights(b[1], 'v') - totalWeights(a[1], 'v'),
          age: (a, b) => b[1].ds?.dpa - a[1].ds?.dpa,
          pos: (a, b) => totalWeights(b[1], 'p') - totalWeights(a[1], 'p'),
          neg: (a, b) => totalWeights(b[1], 'n') - totalWeights(a[1], 'n')
        }) || {
          Weight: (a, b) => b[1].w - a[1].w,
          vis: (a, b) => b[1].v - a[1].v,
          age: (a, b) => b[1].ds?.dpa - a[1].ds?.dpa,
          pos: (a, b) => b[1].p - a[1].p,
          neg: (a, b) => b[1].n - a[1].n
        };
        return (Object.entries(folderList) || [])
          .filter(([did, { th, tg }]) => {
            //console.log('did', did, hasThemes(selectedThemes, th, customThemes, tg));
            return !length || hasThemes(selectedThemes, th, customThemes, tg);
          })
          .sort(sorters[skimmerSort])
          .reduce((all, [did, doc]) => {
            all[did] = doc;
            return all;
          }, {});
      }
      function totalWeights(item, prop) {
        return selectedThemesKeys.reduce((total, theme) => total + item.themes[theme]?.[prop] || 0, 0);
      }
      function hasThemes(selectedThemes, th, customThemes, tg) {
        //Object.keys(selectedThemes);
        const cts = Object.keys(selectedThemes || {}).filter(k => k / 1).map(k => customThemes[k]);
        //console.log(4232, cts, th?.join(', '), th?.some(t => selectedThemes[(t || '').replace(/\s/, '-')]));
        //console.log(4232, cts, Object.keys(selectedThemes || {}).join(', '), '\n\n', th?.join(', '), th?.some(t => selectedThemes[t]));
        return th?.some(n => selectedThemes[n]) || cts?.some(ct => hasKeywords(ct, tg));
        function hasKeywords({ selectedTags, andOr }, tg) {
          let r = true;
          const keys = Object.keys(selectedTags || {});
          //console.log('hasKeywords', keys, tg?.join(', '));
          //todo: aliases
          if (andOr === 'and') {
            keys.forEach(tag => {
              r = r && tg?.includes(tag);
            });
          } else if (andOr === 'or') {
            if (keys.length) {
              r = tg?.some(n => selectedTags[n]);
            }
          } else {
            keys.forEach(tag => {
              r = r && !tg?.includes(tag);
            });
          }
          return r;
        }
        //return Object.keys(selectedThemes).some(({ n }) => th?.includes(n));
        //return th?.filter(t => selectedThemes[t]).length === Object.keys(selectedThemes).length;
      }
    },
    fundPercentage() {
      const { engage, engageSection, engageNewOnly, dividendOnly, styleFilter, engageFilteredPublishers, percentage, engageSelectedRegions: regions, engageSelectedSectors: sectors } = this;
      console.log('fundPercentage', engageNewOnly, dividendOnly, styleFilter, Object.keys(regions).length, Object.keys(sectors).length);
      return (engageNewOnly || dividendOnly || styleFilter || Object.keys(regions).length || Object.keys(sectors).length) ? sumPercentages() : engage.subsections[engageSection.earningInsights.id]?.fundPercentageInSubsection;
      function sumPercentages() {
        return engageFilteredPublishers.reduce((total, { id }) => {
          return total += percentage(id, false);
        }, 0);
      }
    },
    somePubs() {
      return Object.keys(this.publishers).filter((k, i) => i < 5);
    },
    mean() {
      const values = Object.values(this.spotlightData || {});
      return values.map(({ ar }) => ar).reduce((total, ar) => total += ar, 0) / values.length;
    },
    riskMean() {
      const values = Object.values(this.spotlightData || {});
      return values.map(({ rr }) => rr).reduce((total, rr) => total += rr, 0) / values.length;
    },
    opportunityMean() {
      const values = Object.values(this.spotlightData || {});
      return values.map(({ 'or': v }) => v).reduce((total, v) => total += v, 0) / values.length;
    },
    insightsMean() {
      const values = Object.values(this.spotlightData || {});
      return values.map(({ ir: v }) => v).reduce((total, v) => total += v, 0) / values.length;
    },
    spotlightData() {
      const { spotlight, spotlightSource } = this;
      console.log('spotlightData', spotlight, spotlightSource, spotlight?.[spotlightSource || 'ubs']);
      return spotlight?.[spotlightSource || 'ubs'];
    }
  },
  methods: {
    ...mapActions([
      'loadEngageRoboReport',
      'toggleEngageSelectedDocument',
      'toggleEngageSelectedPublisher',
      'toggleSelectedWatchlistDocType',
      'toggleEngageSelectedTheme',
      'engageExitClicked',
      'insightClicked',
      'insightCopied',
      'videoClicked'
    ]),
    polarEnter() {
      clearTimeout(showWedgesTimer);
      showWedgesTimer = setTimeout(() => (this.showWedges = true), 700);
    },
    polarLeave() {
      clearTimeout(showWedgesTimer);
      showWedgesTimer = setTimeout(() => (this.showWedges = false), 1000);
    },
    toggleAndOr() {
      const { andOr } = this;
      // this.andOr = { and: 'or', or: 'nor', nor: 'and' }[andOr];
      this.andOr = { and: 'or', or: 'and' }[andOr];
    },
    topFilterToggle() {
      const { sectionThemesParentsOnly, sectionThemesParentFilter } = this;
      if (sectionThemesParentFilter) {
        this.sectionThemesParentFilter = null;
        this.sectionThemesParentsOnly = false;
      } else {
        this.sectionThemesParentsOnly = !sectionThemesParentsOnly;
      }
    },
    hasVideos(theme) {
      // const { engage: { scenes } } = this;
      //return !!scenes?.[theme]?.videoIds?.split('|');
      return !!this.spotlightData?.[theme]?.vc;
    },
    hasTweets(theme) {
      return !!this.spotlightData?.[theme]?.tc;
    },
    rank(theme) {
      return this.spotlightData?.[theme]?.ar;
    },
    aboveMean(theme) {
      const { mean, rank } = this;
      return rank(theme) > mean;
    },
    hasRisk(theme, spotlightData) {
      return this.spotlightData?.[theme]?.rr;
    },
    aboveRisk(theme) {
      const { hasRisk, riskMean } = this;
      return hasRisk(theme) > riskMean;
    },
    hasOpportunity(theme) {
      return this.spotlightData?.[theme]?.or;
    },
    aboveOpportunity(theme) {
      const { hasOpportunity, opportunityMean } = this;
      return hasOpportunity(theme) > opportunityMean;
    },
    hasInsights(theme) {
      return this.spotlightData?.[theme]?.ir;
    },
    aboveInsights(theme) {
      const { hasInsights, insightsMean } = this;
      return hasInsights(theme) > insightsMean;
    },
    async makeImage() {
      const el = document.querySelector('.widget');
      const { width, height } = el.getBoundingClientRect();
      const canvas = await html2canvas(el, { width, height });
      /*const canvas = await html2canvas(document.querySelector('.widget'), {
        width: 500,
        height: 500,
        windowWidth: 500,
        windowHeight: 500
      });*/
      window.ccc = canvas;
      document.body.appendChild(canvas);
      canvas.toBlob(blob => navigator.clipboard.write([new window.ClipboardItem({'image/png': blob})]));
      // todo: change this to a toast
      /*
      this.$notify({
            group: 'tb',
            title: 'Name is required',
            text: 'Press the escape key to delete',
            width: '30%',
            duration: 25000
          });
       */
      console.log('copied');
      this.hideWidget = true;
      // html2canvas(document.querySelector('.stocks-wrap')).image({
      //   // pageTarget: '.stocks-wrap',
      //   // captureHiddenClass: 'vti__hidden',
      //   // captureShowClass: 'vti__show',
      //   // captureActiveClass: 'vti__active',
      //   fileName: 'weave-widget',
      //   fileType: 'png',
      //   returnAction: 'clipboard'//, // blob, base64, canvas, clipboard, newWindow
      //   //callback: (img) => { return img } // modifies what image is returned
      // });
    },
    setTimeout(fn, delay) {
      setTimeout(fn, delay);
    },
    openTheme(title) {
      this.engageTheme = title;
    },
    hasThemes(section) {
      return section?.themesInsights?.themes?.length;
    },
    stockMetadata(id) {
      return this.engage?.scenes?.[id]?.stockMetadata || {};
    },
    isNew(id) {
      return this.stockMetadata(id).fundHoldingInfo?.isNew;
    },
    pays(id) {
      return this.stockMetadata(id).fundHoldingInfo?.paysDividend;
    },
    region(id) {
      const { stockMetadata, engageRegions: regions } = this;
      const [code, region] = Object.entries(regions).find(([_, region]) => region === stockMetadata(id).region);
      return { code, region };
    },
    percentage(id, label = true) {
      return this.stockMetadata(id).fundHoldingInfo?.[label && 'percentageLabel' || 'percentage'];
    },
    capStyle(id) {
      //console.log('capStyle', this.engage?.scenes || 99, id);
      const [size, kind] = (this.stockMetadata(id)?.style || '').toLowerCase().split(/\scap\s/);
      return { size, kind };
    },
    clearBadgeTimer() {
      clearTimeout(badgeEnterTimer);
    },
    badgeEnter() {
      clearTimeout(badgeEnterTimer);
      badgeEnterTimer = setTimeout(() => (this.engageShowPubBadges = true), 3000);
    },
    leaveFilters() {
      clearTimeout(badgeTimer);
      clearTimeout(badgeEnterTimer);
      badgeTimer = setTimeout(() => (this.engageShowPubBadges = false), 5000);
    },
    toggleRegion(region, exclusive) {
      const { engageSelectedRegions } = this;
      const tmp = { ...engageSelectedRegions };
      let onlyThis = exclusive;
      if (tmp[region]) {
        onlyThis = false;
        delete tmp[region];
      } else {
        tmp[region] = true;
      }
      this.engageSelectedRegions = (onlyThis && { [region]: true }) || { ...tmp };
    },
    toggleSector(sector, exclusive) {
      const { engageSelectedSectors } = this;
      const tmp = { ...engageSelectedSectors };
      let onlyThis = exclusive;
      if (tmp[sector]) {
        onlyThis = false;
        delete tmp[sector];
      } else {
        tmp[sector] = true;
      }
      this.engageSelectedSectors = (onlyThis && { [sector]: true }) || { ...tmp };
    },
    async fetchReportCard({ reportCard, id }) {
      //todo: refactor this to allow launching the report card from scene
      console.log('fetchReportCard', reportCard, reportCard?.watchList);
      const wl = (this.wlContext = reportCard?.watchList);
      // this.reportCardReady = false;
      if (wl) {
        this.reportCardReady = false;
        // todo: caching
        await this.$store.dispatch('loadWatchlistLite', wl);
        await (this.watchlistThemesRefPub = id);
        await (this.watchlistThemesParentFilter = 'ESG themes');
        this.reportCardReady = true;
      }
    },
    engageMaxAgeNumber(text) {
      return {
        'last quarter': 93, 'last two quarters': 186, 'last year': 365, 'last two years': 730, 'last five years': 1825
      }[text];
    },
    filteredInsights(insights) {
      const { engageKeywords } = this;
      //console.log('filteredInsights', engageKeywords, insights);
      return (
        (engageKeywords &&
          insights.filter(({ k, kw = [] }) => {
            // console.log('filterInsights', k, kw);
            return engageKeywords.split(/\s+/).every(testWord);
            function testWord(word) {
              const tester = new RegExp(escapeRegExp(word), 'i');
              return tester.test(`${ k || '' }|${ kw || '' }`);
            }
            function escapeRegExp(s) {
              return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`; // $& means the whole matched string
            }
          })) ||
        insights
      );
    },
    zoomDoc({ target, clientX, clientY }) {
      // return;
      clearTimeout(zoomTimer);
      zoomTimer = setTimeout(() => {
        const { folderZoomedDoc } = this;
        const pn = target.parentNode;
        const id = pn.getAttribute('id');
        if ( folderZoomedDoc.id !== id) {
          const img = pn.getAttribute('bg');
          console.log('zoomDoc', id, img, target);
          // const { top, left, width, height } = target.getBoundingClientRect();
          const { top, left, width, height } = pn.getBoundingClientRect();
          const { scrollY, scrollX } = window;
          //console.log('zoomDoc top left', top, left, scrollY, scrollX);
          // todo: window edge detection
          this.folderZoomedDoc = { top: top + scrollY, left: left + scrollX, width, height, img, id, clientX, clientY };
        }
      }, 500);
    },
    docs(section) {
      return section?.docInsights?.documents;
    },
    docTypeSelected(docType) {
      const { selectedWatchlistDocTypes } = this;
      const length = Object.keys(selectedWatchlistDocTypes).length;
      return !length || selectedWatchlistDocTypes[docType];
    },
    async playVid(items, index) {
      if (!this.currentVideo) {
        this.collapsed = false;
      }
      const item = items[index];
      this.videoClicked(['section viewer', this.engageSelectedSection, item]);
      if (item) {
        if (this.player?.playVideo) {
          console.log('have player', item);
          //this.player.playVideo(item);
        }
        await (this.currentVideo = item);
      }
      console.log('playVid', items);
      await (this.playlist = items);
    },
    filteredPages(id) {
      const { engage: { banner: { pages, documents } }, pdf } = this;
      id = id || pdf.replace(/^https\:\/\/content\.weave\.ai\/documents\/|\-\d+\.pdf$/g, '');
      //console.log('filteredPages id', id);
      return pages.filter(({ docId }) => docId === id);
    },
    tocPages(id) {
      const { engage: { banner: { pages, documents } }, pdf, engageRoboReport } = this;
      if (!pdf) {
        return [];
      }
      id = id || pdf.replace(/^https\:\/\/content\.weave\.ai\/documents\/|\-?\d*\.pdf$/g, '');
      //console.log('filteredPages id', id);
      const { pgc } = documents.find(d => d.id === id) || findDocumentPgc();

      console.log('engage tocPages', pgc, id, documents, documents.find(d => d.id === id));
      const { engageTocPageCount } = this;
      return Array.from(new Array(pgc || engageTocPageCount), (item, index) => {
        //console.log('tocPages array from', index);
        const pgn = index + 1;
        const base = pdf.replace(/\d*\.pdf$/, '') + (pgc > 1 && pgn || '');
        const imgu = base.replace(/\/documents\//, '/picture-images/');
        return {
          pgn,
          url: base + '.pdf',
          imgu: (imgu + (!/\-?\d+$/.test(imgu) && '-1' || '') + '.png').replace(/\-\-(\d+\.png)$/, '-$1'),
          selected: false
        };
      });
      // return pages.filter(({ docId }) => docId === id);
      function findDocumentPgc() {
        console.log('find document info', id, engageRoboReport);
        return Object.values(engageRoboReport?.insights || {}).find(({ did }) => did === id) || {};
      }
    },
    date(d) {
      return new Date(d);
    },
    async openReport() {
      this.roboReportLaunchedFromWatchList = !this.chartShown;
      await (this.selectedWatchlistThemes = {});
      await (this.engageThemesParentFilter = '');
      this.chartShown = this.roboReportShown = this.engageThemesShown = true;
    },
    async openESGReport() {
      this.roboReportLaunchedFromWatchList = !this.chartShown;
      await (this.selectedWatchlistThemes = {});
      await (this.engageThemesParentFilter = 'ESG themes');
      this.chartShown = this.roboReportShown = this.engageThemesShown = this.roboReportLaunchedFromWatchList = true;
    },
    async openCustomReport(theme) {
      await (this.selectedWatchlistThemes = {});
      await (this.engageThemesParentFilter = theme);
      this.chartShown = this.roboReportShown = this.engageThemesShown = this.roboReportLaunchedFromWatchList = true;
    },
    launchNonGenRoboReport({ keyCode }) {
      clearTimeout(shiftTimer);
      shiftTimer = setTimeout(() => (recentShift = false), 400);
      if (recentShift) {
        //console.log('recentShift');
        this.chartShown = this.roboReportShown = this.engageThemesShown = true;
        recentShift = false;
      } else {
        recentShift = true;
      }
    },
    //...mapActions(['loadDoco', 'loadInsights', 'loadFolder']),
    async loadRobo(key, shift, name) {
      console.log('shift', !!shift);
      const { $store: { dispatch } } = this;
      if (shift) {
        await this.openReportCard(name);
      } else {
        this.engageShown = false;
        dispatch('loadRobo', key);
      }
    },
    async openReportCard(pub) {
      //console.log('openReportCard', this.watchlistThemesRefPub, pub);
      if (this.watchlistThemesRefPub !== pub) {
        const { engage = {} } = this;
        const { scenes = {} } = engage;
        const { reportCards = [] } = scenes[pub] || {};
        const [reportCard] = reportCards;
        if (reportCard) {
          console.log('have report card');
          await this.fetchReportCard({ reportCard, id: pub });
        }
      }
      await (this.watchlistThemesRefPub = pub);
      await (this.watchlistThemesParentFilter = 'ESG themes');
      this.reportCardReady = true;
      this.engageReportCardShown = true;
      //return;
      // console.log('engage openReportCard', name);
      // const { engageHideESG, openReport, openESGReport, publishers } = this;
      // await (engageHideESG && openReport || openESGReport)();
      // const [pubKey] = Object.entries(publishers).find(([_, { n }]) => n === name);
      // console.log(name, pubKey);
      // if (pubKey) {
      //   await (this.engageThemesRefPub = pubKey);
      // }
      // this.refPubInfoShown = true;
    },
    // async openReportCard(name) {
    //   console.log('engage openReportCard', name);
    //   const { engageHideESG, openReport, openESGReport, publishers } = this;
    //   await (engageHideESG && openReport || openESGReport)();
    //   const [pubKey] = Object.entries(publishers).find(([_, { n }]) => n === name);
    //   console.log(name, pubKey);
    //   if (pubKey) {
    //     await (this.engageThemesRefPub = pubKey);
    //   }
    //   this.refPubInfoShown = true;
    // },
    preLoadRobo(key) {
      // todo: implement
    },
    filteredDocs(topDocs) {
      return topDocs.slice(0, 14);
    },
    filteredThemes(topThemes) {
      return topThemes.slice(0, 18);
      const { themesFilter, themes} = this;
      //console.log('thms2', Object.values(themes).map(({ t, c }) => `${ t }: ${ c }`).join(', '));
      const filters = themesFilter?.split(/\s+/).map(item => new RegExp(item.toLowerCase().replace(/\W/g, '.'), 'i'));
      return Object.values(themes).filter(({ k }) => filters.every(filter => filter.test(k.join('|')))).sort((a, b) => b.c - a.c);
    },
    async click(key, id) {
      console.log('key/id', key, id);
      await this.loadInsights({ id });
      await (this.folderDoco = id);
      await (this.insightsDoco = id);
      await (this.roboFolder = key);
      await (this.backToRobo = true);
      //await (this.loadInsights(id));
      await this.loadDoco(id);
      await this.loadFolder(key);
      this.roboWeaveShown = this.notificationsShown = false;
      window.history.pushState({ fromRobo: true }, 'Weave - folder view');
      console.log('state added from robo folder view');
    }
  },
  components: { scene: () => import('./scene'), theme: () => import('./theme'), stocks: () => import('./stocks'), fund: () => import('./fund'), perf: () => import('./perf'), styles: () => import('./styles'), viewer: () => import('@/components/topo-components/viewer'), reportCard, reportOpener, clipboard, highlighter },
  mounted() {
    const pickOne = () => {
      const { sortedThemes, aboveMean } = this;
      const polarKeys = sortedThemes.map(([key]) => key).filter(key => aboveMean(key));
      // console.log('polarThemes', polarKeys);
      //const
      // clearTimeout(glareTimer);
      this.glareKey = polarKeys[Math.floor(Math.random() * polarKeys.length)];
      glareTimer = setTimeout(pickOne, Math.random() * 4000 + 1250);
      // console.log('glare', this.glareKey);
    };
    pickOne();
  }
  // async mounted() {
    // console.log('publishers keys', url);
  // }
  /*/ mounted() {
    // const [_, name] = (/[\?\&\;]rc\=([^\;\&]+)/.exec(location.search) || []);
    // if (name) {
    //   console.log('rc', name);
    //   this.openReportCard(name);
    // }
  // }//*/
};
</script>
<style lang="scss" scoped>
@import '../../scss/global';
.engage-wrap {
  .engage {
    //display: ;
    /*position: fixed;
    top: 5rem;
    bottom: 1rem;
    //left: 21vw;
    left: 51vw;
    //width: 76vw;
    width: 46vw;*/
    position: absolute;
    top: 2rem;
    z-index: 1;
    width: 100vw;
    max-width: 100vw;
    min-height: 100vh;
    background-color: white;
    //box-shadow: 1px 1px 3px black;
    //border-radius: 0.25rem;
    transform: translate3d(-110vw, 0, 0);
    transform-origin: top left;
    transition: transform 700ms ease-in-out;
    will-change: transform;
    //z-index: -1;
    cursor: default;
    //transform: none;
    box-sizing: border-box;
    padding: 5rem 1rem 0;
    &.has-ticker {
      padding-top: 22.5rem;
      top: 4rem;
      & > .banner {
        & > .view-mode {
          top: 21.4rem;
        }
      }
    }
    &.shown {
      //transform: none;
      transform: translate3d(0, 0, -1px);
    }
    & > .opener {
      cursor: pointer;
      display: none;
      position: fixed;
      top: 1rem;
      left: 110%;
      //margin-left: 3rem;
      //transform: translate3d(5.5rem, 0, 0);
      transform: translate3d(-2rem, 0, 0);
      font-size: 2rem;
      padding: 0.25rem 0.125rem;
      /*border-top-right-radius: 0.25rem;*/
      /*border-bottom-right-radius: 0.25rem;*/
      border-radius: 0.25rem;
      color: white;
      background-color: $brn;
      opacity: 0.75;
      transition: opacity 250ms ease-in-out 1500ms;
      will-change: opacity;
      &:hover {
        opacity: 1;
      }
    }
    &:not(.shown) > .opener {
      display: block;
      transition-delay: 10ms;
    }
    & > .banner {
      display: grid;
      //grid-template-columns: 60% 39.5%;
      grid-template-columns: 50% 49.5%;
      grid-column-gap: 0.5%;
      width: 100vw;
      .view-mode {
        position: absolute;
        top: 4rem;
        right: 0.5rem;
        width: 6.5rem;
        height: 2rem;
        //outline: 1px solid blue;
        opacity: 0;
        pointer-events: none;
        transition: opacity 250ms ease-in-out;
        display: grid;
        z-index: 1;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 0.25rem;
        //background-color: #efefef;
        border-radius: 0.25rem;
        //padding: 0.125rem;
        border: 1px solid rgba($brn, 0.5);
        background-color: white;
        $padding: 0.125rem;
        & > * {
          cursor: pointer;
          position: relative;
          background-color: white;
          box-sizing: border-box;
          opacity: 0.5;
          border-radius: 0.25rem;
          overflow: hidden;
          //border: 1px solid #efefef;
          &.on,
          &:hover {
            opacity: 1;
          }
          &::before {
            position: absolute;
            top: $padding;
            left: $padding;
            bottom: $padding;
            width: 30%;
            content: '';
            background-color: #ccc;
            box-sizing: border-box;
            border: 1px solid white;
            border-top-left-radius: 0.25rem;
            border-bottom-left-radius: 0.25rem;
          }
          &::after {
            position: absolute;
            top: $padding;
            right: $padding;
            bottom: $padding;
            width: 30%;
            content: '';
            background-color: #ccc;
            box-sizing: border-box;
            border: 1px solid white;
            border-top-right-radius: 0.25rem;
            border-bottom-right-radius: 0.25rem;
          }
        }
        .a-b {
          //background-color: red;
          &:after {
            width: 65%;
            background-color: $brn;
          }
        }
        .a-b-c {
          &::before {
            //width: 20%;
          }
          .v {
            position: absolute;
            top: 0.2rem;
            left: 38%;
            right: 30%;
            bottom: 0.2rem;
            background-color: $brn;
            //background-color: blue;
          }
          //background-color: blue;
        }
        .b-c {
          &::before {
            width: 65%;
            background-color: $brn;
          }
          //background-color: green;
        }
      }
      &.has-viewer {
        //grid-template-columns: 20% 77%;
        //grid-column-gap: 1rem;
        //&.has-fund {
        grid-template-columns: 22rem 55% 19.5%;
        grid-column-gap: 3rem;
        &.has-fund {
          grid-template-columns: 22rem 1fr 18rem;
          grid-column-gap: 1rem;
        }
        &:not(.has-fund) { //todo: this should be up on .engage
          grid-template-columns: 22rem 1fr 33rem;
          &.has-themes-pubs {
            //grid-template-columns: 22rem 1fr 60rem;
            grid-template-columns: 22rem 1fr 30rem;
            &.bc {
              grid-template-columns: 1fr 60rem !important;
            }
          }
          &.ab {
            grid-template-columns: 22rem 1fr;
          }
          &.bc {
            &:not(.has-fund) {
              grid-template-columns: 1fr 46rem;
            }
          }
        }
        &.ab {
          grid-template-columns: 22rem 74.5%;
          .publishers-section {
            display: none;
          }
        }
        &.bc {
          grid-template-columns: 74.5% 20%;
          .key-documents {
            display: none;
          }
        }
        .view-mode {
          opacity: 1;
          pointer-events: all;
        }
        //}
        .publishers-section {
          .publishers {
            grid-template-columns: repeat(3, 3rem) !important;
            max-height: calc(100vh - 7.5rem);
            overflow-y: auto;
          }
        }
        & > .key-documents {
          display: flex;
          flex-wrap: wrap;
          max-height: calc(100vh - 7.5rem);
          overflow-y: auto;
          height: auto;
          & > .key-document {
            &.has-pages {
              width: 21.5rem;
              &.two-pages {
                .pages {
                  grid-template-columns: repeat(1, 6rem);
                }
              }
            }
          }
        }
      }
      & > .publisher {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
        .bg {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: no-repeat center;
          background-position-y: -15rem;
          background-attachment: fixed;
          background-size: 80%;
          opacity: 0.15;
        }
      }
      & > .key-documents {
        display: grid;
        grid-template-columns: repeat(2, 27.5rem);
        height: 1rem;
        //grid-column-gap: 0.5rem;
        //display: flex;
        //flex-wrap: wrap;
        .key-document {
          cursor: pointer;
          position: relative;
          height: 22rem;
          background-color: rgba(white, 0.7);
          border: 4px solid rgba($brn, 0.25);
          //box-shadow: 0 0 6px rgba($brn, 0.1);
          border-radius: 0.25rem;
          box-sizing: border-box;
          padding: 0.5rem 0.25rem 1rem 14rem;
          margin-right: 2.1rem;
          margin-bottom: 2rem;
          &:hover {
            & > .date {
              opacity: 1;
            }
          }
          &.has-pages {
            width: 26rem;
            &.two-pages {
              .pages {
                grid-template-columns: repeat(1, 1fr);
                //grid-template-columns: repeat(1, 8rem);
              }
            }
            .pages {
              display: grid;
            }
            & > .title {
              right: 11.75rem;
            }
          }
          & > .title {
            position: absolute;
            top: 0.5rem;
            left: 0.25rem;
            right: 0.25rem;
            text-align: center;
            color: $brn;
            font-size: 0.8rem;
            text-transform: uppercase;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            //overflow: hidden;
            //text-overflow: ellipsis;
            //white-space: nowrap;
            //transform: translate3d(-50%, 0, 0);
            //font-size: 1.4rem;
            z-index: 1;
          }
          .date {
            position: absolute;
            bottom: 0.5rem;
            left: 0.5rem;
            color: $brn;
            font-size: 0.8rem;
            //text-transform: uppercase;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            opacity: 0;
            transition: opacity 600ms ease-in-out 400ms;
          }
          & > .bg {
            position: absolute;
            top: 2rem;
            left: 0;
            width: 14rem;
            height: 18rem;
            background: no-repeat center white;
            background-size: contain;
          }
          .pages {
            display: none;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 0.5rem;
            border-left: 3px solid rgba($brn, 0.35);
            height: 19.5rem;
            align-content: start;
            padding: 0.25rem;
            overflow-y: auto;
            .page {
              cursor: pointer;
              position: relative;
              padding-top: 136%;
              .bg {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                background: no-repeat center white;
                background-size: contain;
              }
            }
          }
        }
      }
      .themes-pubs {
        display: flex;
        justify-content: space-evenly;
        .publishers-section {
          //position: absolute;
          //top: 0;
          //left: 0;
          //bottom: 0;
          //right: 50vw;
          z-index: 1;
          box-sizing: border-box;
          padding-bottom: 6rem;
          .publishers {
            cursor: pointer;
            box-sizing: border-box;
            padding: 0.5rem;
            display: grid;
            //grid-template-columns: repeat(7, 3rem);
            grid-template-columns: repeat(7, 5.5rem);
            //grid-gap: 0.25rem;
            //grid-gap: 3rem;
            grid-gap: 2rem;
            z-index: 1;
            &.skinny {
              grid-template-columns: repeat(4, 5.5rem);
            }
            .publisher {
              position: relative;
              padding-top: 100%;
              .bg {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                background: no-repeat center;
                background-size: contain;
              }
            }
          }
        }
        & > .themes-section {
          position: relative;
          & > .filters {
            position: absolute;
            top: -1rem;
            left: 13.5rem;
            display: flex;
            z-index: 1;
            & > * {
              cursor: pointer;
              font-family: 'Assistant', sans-serif;
              font-size: 0.7rem;
              text-transform: uppercase;
              color: $brn;
              font-weight: 500;
              padding: 0.125rem 0.25rem;
              border-radius: 0.25rem;
              margin-left: 0.125rem;
              &.has {
                color: rgba($brn, 0.5);
              }
              &.both {
                &.has-videos {
                  border-top-right-radius: 0;
                  border-bottom-right-radius: 0;
                }
                &.has-tweets {
                  border-top-left-radius: 0;
                  border-bottom-left-radius: 0;
                }
              }
              &.on {
                background-color: $brn;
                color: white;
              }
            }
            .has-videos,
            .has-tweets {
              white-space: nowrap;
            }
          }
          .items {
            display: grid;
            grid-template-columns: repeat(5, 8rem);
            //background-color: white;
            box-sizing: border-box;
            padding-top: 2rem;
            padding-bottom: 8rem;
            transform: translate3d(2.25rem, 0, 0);
            &.skinny {
              //transform: translate3d(2rem, 0, 0);
              grid-template-columns: repeat(3, 8rem);
              & > .item {
                &:nth-child(6n + 1),
                &:nth-child(6n + 2),
                &:nth-child(6n + 3) {
                //&:nth-child(10n + 4),
                //&:nth-child(10n + 5) {
                  //background-color: yellow;
                  margin-top: -2rem;
                  margin-left: -4rem;
                  margin-bottom: -2rem;
                }
              }
            }
            &:not(.skinny) {
              & > .item {
                &:nth-child(10n + 1),
                &:nth-child(10n + 2),
                &:nth-child(10n + 3),
                &:nth-child(10n + 4),
                &:nth-child(10n + 5) {
                  //background-color: yellow;
                  margin-top: -2rem;
                  margin-left: -4rem;
                  margin-bottom: -2rem;
                }
              }
            }
            &:hover {
              .item {
                & > .tile {
                  background-color: white;
                  opacity: 0.6;
                  & > .bg {
                    transform: scale(0.7);
                  }
                  & > .title {
                    opacity: 1;
                  }
                }
              }
            }
            .item {
              position: relative;
              width: 8rem;
              height: 8rem;
              //background-color: rgba(#3498db, 0.5);
              //background-color: white;
              &.themes-flip-list-move {
                transition-duration: 1000ms;
              }
              &:hover {
                z-index: 1;
                & > .tile {
                  opacity: 1;
                  transform: scale(1.2);
                  background-color: white;
                  box-shadow: 0 0 3px rgba(#282828, 1);
                  & > .bg {
                    transform: scale(0.79);
                  }
                  & > .title {
                    opacity: 0;
                  }
                }
                & > .title {
                  opacity: 1;
                  transform: translate3d(-50%, 1rem, 0) rotate(-27.5deg);
                  //transform: translate3d(-50%, 1rem, 0);
                }
              }
              //&:nth-child(5) + .item,
              //&:nth-child(10n+5) + .item {


              //&:nth-child(10n + 1),
              //&:nth-child(10n + 2),
              //&:nth-child(10n + 3),
              //&:nth-child(10n + 4),
              //&:nth-child(10n + 5) {
              //  //background-color: yellow;
              //  margin-top: -2rem;
              //  margin-left: -4rem;
              //  margin-bottom: -2rem;
              //}

              & > .title {
                position: absolute;
                //top: 67%;
                top: 100%;
                left: 50%;
                box-sizing: border-box;
                padding: 0.3rem 0.5rem;
                white-space: nowrap;
                border-radius: 0.25rem;
                box-shadow: 0 2px 2px rgba(#282828, 0.5);
                background-color: white;
                min-width: 9.5rem;
                color: $brn;
                font-weight: 200;
                font-size: 1.2rem;
                font-family: 'Assistant', sans-serif;
                margin-top: -1px;
                transform: translate3d(-60%, -0.5rem, 0)  rotate(-27.5deg);
                //transform: translate3d(-50%, -0.5rem, 0);
                opacity: 0;
                pointer-events: none;
                transition: all 250ms ease-in-out 1s;
              }
              & > .tile {
                cursor: pointer;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
                opacity: 0.43;
                transition: all 250ms ease-in-out;
                //overflow: hidden;
                &.has-polar {
                  opacity: 1;
                  &:hover > .bg {
                    transform: scale(0.875);
                  }
                  & > .glare {
                    position: absolute;
                    top: 0;
                    left: -20rem;
                    right: -10rem;
                    height: 1rem;
                    background-color: rgba(white, 0.55);
                    box-shadow: 0 0.125rem 1rem rgba(white, 0.5);
                    &.on {
                      display: block;
                      //transform: rotate(-30deg);
                      animation: skim 4s infinite;
                    }
                    @keyframes skim {
                      0% {
                        transform: rotate(-30deg) translate3d(0, -4rem, 0);
                      }
                      5% {
                        transform: rotate(-30deg) translate3d(0, 2rem, 0);
                      }
                      20% {
                        transform: rotate(-30deg) translate3d(0, 16rem, 0);
                      }
                      //20% {
                        //transform: rotate(-30deg) translate3d(6rem, 6rem, 0);
                      //}
                      //50% {
                      //  transform: rotate(-30deg) translate3d(16rem);
                      //}
                      100% {
                        transform: rotate(-50deg) translate3d(0, 40rem, 0);
                      }
                    }
                  }
                  & > .bg {
                    transform: scale(1);
                  }
                }
                & > .glare {
                  position: absolute;
                  display: none;
                }
                & > .polar {
                  position: absolute;
                  top: 0;
                  right: -2rem;
                  //top: 2.5rem;
                  //right: 2rem;
                  width: 4.125rem;
                  height: 4.125rem;
                  border-radius: 50%;
                  background-color: white;
                  transform: scale(0.75);
                  transition: transform 250ms ease-in-out;
                  &:hover {
                    transform: scale(1.2);
                  }
                  &::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 1.125rem;
                    height: 1.125rem;
                    transform: translate3d(-50%, -50%, 1px);
                    background-color: white;
                    box-sizing: border-box;
                    border: 0.25rem solid white;
                    border-radius: 50%;
                  }
                  //& > .border {
                  //  pointer-events: none;
                  //  position: absolute;
                  //  top: 1.75rem;
                  //  left: 0;
                  //  bottom: 0;
                  //  right: 50%;
                  //  box-sizing: border-box;
                  //  border: 1px solid #dadada;
                  //  border-bottom-left-radius: 100%;
                  //  z-index: 2;
                  //  overflow: hidden;
                  //}
                  .wedge {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    box-sizing: border-box;
                    border: 0.25rem solid white;
                    //border: 1px solid blue;
                    //border-top-color: black;
                    border-radius: 50%;
                    //transform-origin: bottom right;
                    transform: rotate(-52deg);
                    overflow: hidden !important;
                    //outline: 1px solid black;
                    svg {
                      opacity: 0.8;
                      position: absolute;
                      bottom: 50%;
                      right: 50%;
                      transform: rotate(-45deg) scale(5) translate3d(0.75px, -1.125px, 0);
                      //border: 1px solid black;
                    }
                    & + .wedge {
                      transform: rotate(-95deg);
                      svg {
                        transform: rotate(-45deg) scale(5) translate3d(0.5px, -2.125px, 0);
                        //transform: rotate(-149deg) translate3d(11.75rem, -9.125rem, 0);
                      }
                      & + .wedge {
                        transform: rotate(-135deg);
                        svg {
                          transform: rotate(-45deg) scale(5) translate3d(0, -1.5px, 0);
                          //transform: rotate(-180deg) translate3d(28.75rem, -2.6rem, 0);
                        }
                      }
                    }
                  }

                  //& > .slice {
                  //  width: 0;
                  //  height: 0;
                  //  border-left: 0.9rem solid transparent;
                  //  border-right: 0.9rem solid transparent;
                  //  border-top: 2rem solid rgba($brn, 0.5);
                  //  border-radius: 50%;
                  //  transform: rotate(-120deg);
                  //  transform-origin: bottom center;
                  //  & + .slice {
                  //    transform: rotate(-167deg) translate3d(0, 2rem, 0);
                  //  }
                  //}
                }
                & > .title {
                  position: absolute;
                  top: 72%;
                  right: 0;
                  width: 5rem;
                  transform: rotate(-24.5deg);
                  background-color: white;
                  white-space: nowrap;
                  box-sizing: border-box;
                  padding: 0.25rem 0.125rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  opacity: 0;
                  text-align: center;
                  pointer-events: none;
                  transition: opacity 250ms ease-in-out;
                }
                & > .bg {
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  background: white center no-repeat;
                  background-size: cover;
                  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
                  transform: scale(0.98);
                  transition: transform 250ms ease-in-out;
                }
              }
            }
          }
        }
      }
    }
    & > .items {
      max-width: 100vw;
      box-sizing: border-box;
      padding: 1rem;
      display: grid;
      grid-template-columns: repeat(24, 1fr);
      grid-column-gap: 0.1rem;
      //grid-column-gap: 2rem;
      grid-row-gap: 2rem;
      & > .item {
        cursor: pointer;
        box-sizing: border-box;
        padding: 0.25rem;
        border: 2px solid #f5f5f5;
        border-radius: 0.125rem;
        background-color: white;
        transition: all 200ms ease-in-out;
        will-change: all;
        transform-origin: center;
        &.full {
          border-color: orange;
          z-index: 1;
          transform: scale(1.2);
        }
        &.before {
          transform: scale(0.9) translate3d(0.4rem, 0, 0);
        }
        &.after {
          transform: scale(0.9) translate3d(-0.4rem, 0, 0);
        }
        &.on {
          border-color: orange;
        }
        & > .bg {
          padding-top: 100%;
          background: white no-repeat center;
          background-size: contain;
        }
      }
    }
    & > .sorter {
      position: absolute;
      top: 0;
      left: 0;
    }
    //&.open {
    .heading {
      font-size: 1.5rem;
      font-weight: 200;
      position: absolute;
      top: 0.25rem;
      left: 0.5rem;
      opacity: 0.4;
      transition: opacity 250ms ease-in-out;
      will-change: opacity;
    }
    .folders {
      & > .heading {
        color: $brn;
        opacity: 1;
        font-size: 2rem;
        left: 1rem;
      }
      .items {
        display: grid;
        pointer-events: all;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;
        grid-row-gap: 1.25rem;
        padding-right: 20rem;
        //grid-template-columns: repeat(4, 1fr);
        //grid-template-columns: repeat(7, 1fr);
        //overflow: auto;
        //max-height: calc(100vh - 6rem);
      }
    }
    .close {
      pointer-events: all;
      display: block;
    }
    .count {
      display: none;
    }
    //}
    .count {
      position: absolute;
      top: 0;
      left: 100%;
      transform: translate3d(0.5rem, 0, 0);
    }
    .close {
      display: none;
      position: absolute;
      top: 0.25rem;
      right: 0.25rem;
      height: 3rem;
      width: 3rem;
      &:hover {
        &::after {
          color: black;
        }
      }
      &::after {
        color: #dadada;
        cursor: pointer;
        content: '\00d7';
        position: absolute;
        top: -0.3rem;
        right: -0rem;
        font-size: 1.25rem;
        //margin-top: -0.05rem;
        //transform: translate3d(0, -70%, 0);
      }
    }
    & > .widget {
      position: absolute;
      top: 0.5rem;
      left: 0;
      //right: 0;
      background-color: white;
      box-sizing: border-box;
      border: 0.25rem solid rgba($brn, 0.5);
      border-radius: 0.5rem;
      z-index: 18000;
      padding: 2rem;
      transition: all 250ms ease-in-out;
      $size: 7.5rem;
      &.hide {
        transform: translate3d(-100vh, 0, 0);
        pointer-events: none;
        opacity: 0;
      }
      &.landscape {
        & > .title {
          top: 1.2rem;
          left: 0.5rem;
          font-size: 2rem;
        }
        & > .top-items {
          $smallSize: 5rem;
          grid-template-columns: repeat(6, $smallSize) repeat(4, $size);
          .fund-spacer {
            grid-column: 7 / 11;
            grid-row: 1 / span 7;
          }
          .title-spacer {
            display: block;
            grid-column: 1 / 11;
            grid-row: 1 / 2;
            height: 2rem;
          }
          & > .logo {
            grid-column: 3 / span 2;
            grid-row: 2 / span 2;
            outline: 1px solid blue;
            height: 10.7rem;
            border: 3px solid rgba($brn, 0.5);
            border-radius: 0.5rem;
            transform: scale(0.8);
            img {
              width: 100%;
              border-radius: 0.5rem;
              transform: scale(0.9);
            }

          }
        }
      }
      & > .top-items {
        display: grid;
        grid-template-columns: repeat(8, $size);
        grid-gap: 0.5rem;
        .title-spacer {
          display: none;
        }
        .fund-spacer {
          grid-column: 5 / 9;
          grid-row: 1 / span 3;
          min-height: 24.5rem;
        }
        .item {
          position: relative;
          img {
            width: 100%;
          }
        }
      }
      & > .title {
        position: absolute;
        top: 2rem;
        left: 34.25rem;
        right: 0.5rem;
        text-align: center;
        font-size: 1.5rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #8d6e4f;
        font-family: Roboto, serif;
      }
      /deep/ .fund {
        pointer-events: none;
        top: 4.45rem;
        left: 34.5rem;
        border-color: transparent;
        .distribution-wrap {
          visibility: hidden;
        }
        .regions-wrap {
          visibility: hidden;
        }
        .holdings-wrap {
          transform: translate3d(0, 3rem, 0);
        }
      }
      & > .widget-stats {
        position: absolute;
        top: 5rem;
        right: 1.5rem;
        width: 13.5rem;
        height: 21rem;
        display: grid;
        grid-template-rows: repeat(5, 1fr);
        grid-row-gap: 0.5rem;
        box-sizing: border-box;
        padding-left: 4rem;
        padding-right: 4rem;
        //background-color: lightskyblue;
        z-index: 1;
        font-family: 'Assistant', sans-serif;
        font-size: 0.8rem;
        text-transform: uppercase;
        color: rgba($brn, 0.7);
        .stat {
          position: relative;
          border-bottom: 1px solid rgba($brn, 0.125);
          padding-top: 1rem;
          &:last-of-type {
            border-bottom-color: transparent;
          }
          .label {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate3d(-50%, 0.35rem, 0);
            white-space: nowrap;
          }
          .value {
            font-size: 2rem;
            font-weight: 500;
            padding-bottom: 0.125rem;
            //color: rgba($brn, 0.7);
          }
        }
      }
      & > .items {
        display: grid;
        $size: 5rem;
        grid-template-columns: repeat(12, $size);
        //grid-template-columns: repeat(7, 1fr);
        grid-gap: 0.5rem;
        & > .gap {
          grid-column: 1 / 13;
          height: 4rem;
          //background-color: lightskyblue;
        }
        & > .logo {
          grid-column: 5 / span 3;
          grid-row: 3 / span 3;
          border: 3px solid rgba($brn, 0.5);
          border-radius: 0.5rem;
          transform: scale(0.8);
          img {
            width: 100%;
            border-radius: 0.5rem;
            transform: scale(0.9);
          }
        }
        & > .item {
          position: relative;
          //padding-top: 100%;
          //height: $size;
          img {
            width: 100%;
          }
          & > .bg {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background: no-repeat center;
            background-size: contain;
          }
        }
      }
    }
  }
  & > .exit-sections-wrapper {
    position: absolute;
    top: 8rem;
    right: 4rem;
    z-index: 17;
    max-height: 70vh;
    overflow: auto;
    transform: rotate3d(1, 1, 0, 90deg);
    transition: transform 400ms ease-in-out;
    border-radius: 0.5rem;
    border-top: 1px solid $brn;
    border-bottom: 1px solid $brn;
    //transform: translate3d(0, 0, 0);
    &.shown {
      transform: none;
      //transform: translate3d(0, 0, 0);
    }
    & > .close {
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.3rem;
      padding: 0.25rem 0.5rem 1.25rem 0.75rem;
      //background-color: lightskyblue;
      color: $brn;
      opacity: 0.5;
      transition: opacity 250ms ease-in-out;
      &:hover {
        opacity: 1;
      }
    }
    .exit-sections {
      background-color: rgba(white, 0.8);
      &:first-of-type {
        .sub-section {
          border-top-color: transparent;
        }
      }
      &:last-of-type {
        .sub-section {
          border-bottom-color: transparent;
          margin-bottom: 0;
        }
      }
      .sub-section {
        padding: 1rem 2rem 2rem;
        padding-bottom: 1rem;
        border: 1px solid $brn;
        box-shadow: 1px 1px 3px $brn;
        border-radius: 0.5rem;
        background-color: white;
        margin-bottom: 0.5rem;
        & > * {
          color: $brn !important;
        }
        & > .title {
          text-align: center;
          font-weight: 300;
          font-size: 0.9rem;
          text-transform: uppercase;
          color: $brn;
          margin-bottom: 0.5rem;
        }
        a.link {
          display: block;
          background-color: white;
          text-decoration: none;
          border: 2px solid transparent;
          border-radius: 0.5rem;
          transition: border-color 250ms ease-in-out;
          &:hover {
            border-color: rgba($brn, 0.5);
          }
          &.people {
            & > .bg {
              border-radius: 100%;
            }
          }
          &.organization,
          &.people {
            display: grid;
            padding: 1rem;
            grid-template-columns: 5rem 15rem;
            grid-column-gap: 1rem;
            & > .bg {
              height: 5rem;
              grid-row: 1 / 3;
              //border-radius: 100%;
              background: #efefef no-repeat center;
              background-size: cover;
            }
            & > .title {
              text-align: left;
              font-weight: 300;
              font-size: 1.5rem;
              text-transform: uppercase;
              color: $brn;
              grid-column: 2 / 3;
              grid-row: 1 / 2;
            }
            & > .titles {
              grid-column: 2 / 3;
              grid-row: 2 / 3;
              display: flex;
              flex-wrap: wrap;
              //padding: 1rem;
              & > .tag {
                white-space: nowrap;
                margin: 0.125rem;
                font-size: 0.7rem;
                text-transform: uppercase;
                color: $brn;
                &:last-of-type {
                  &::after {
                    display: none;
                  }
                }
                &::after {
                  content: ', ';
                  font-size: 1.1rem;
                  line-height: 0.8rem;
                  color: rgba($brn, 0.8);
                }

              }
            }
          }
        }
      }
    }
  }
  & > .sections-wrap {
    position: fixed;
    bottom: 0.5rem;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    transition: opacity 250ms ease-in-out;
    z-index: 5;
    &.hide {
      opacity: 0;
      pointer-events: none;
    }
    .sections {
      //display: flex;
      display: grid;
      grid-gap: 1rem;
      justify-content: space-evenly;
      //height: 6rem;
      background-color: rgba($brn, 0.6);
      border-radius: 0.25rem;
      box-shadow: 0 0 3px $brn;
      padding: 1rem 2rem;
      &.has-selection {
        .section {
          opacity: 0.7;
          &:hover,
          &.selected {
            opacity: 1;
          }
        }
      }
      .section {
        cursor: pointer;
        position: relative;
        transform-origin: top right;
        text-transform: uppercase;
        font-size: 1.2rem;
        font-weight: 500;
        white-space: nowrap;
        box-sizing: border-box;
        text-align: center;
        //height: 1rem;
        background-color: white;
        color: $brn;
        border: 1px solid rgba($brn, 0.5);
        padding: 0.5rem 0.75rem 0.5rem 4rem;
        border-radius: 0.25rem;
        transition: all 250ms ease-in-out;
        &:hover,
        &.selected {
          border-color: $brn;
          box-shadow: 0 0 2px $brn;
        }
        .for-videos {
          position: absolute;
          top: 0.5rem;
          left: 2.25rem;
          width: 2rem;
          height: 2rem;
          background: no-repeat top left
            url("data:image/svg+xml;charset%3Dutf8,%3Csvg version%3D'1.1' xmlns%3D'http://www.w3.org/2000/svg' xmlns:xlink%3D'http://www.w3.org/1999/xlink' x%3D'0px' y%3D'0px' viewbox%3D'0 0 512 512' xml:space%3D'preserve' preserveaspectratio%3D'xMinYMin meet' width%3D'100%' height%3D'100%' style%3D'fill: %238D6E4F;'%3E%3Cpath transform%3D'scale(0.04)' d%3D'M265,96c65.3,0,118.7,1.1,168.1,3.3l0.7,0h0.7c23.1,0,42,22,42,49.1v1.1l0.1,1.1c2.3,34,3.4,69.3,3.4,104.9v0v0 c0.1,35.6-1.1,70.9-3.4,104.9l-0.1,1.1v1.1c0,13.8-4.7,26.6-13.4,36.1c-7.8,8.6-18,13.4-28.6,13.4h-0.8l-0.8,0c-52.9,2.5-108.8,3.8-166.4,3.8c-3.5,0-7.1,0-10.6,0H256h-0.1c-3.6,0-7.2,0-10.8,0c-57.8,0-113.7-1.3-166.2-3.7l-0.8,0h-0.8 c-10.6,0-20.7-4.8-28.5-13.4c-8.6-9.5-13.4-22.3-13.4-36.1v-1.1l-0.1-1.1c-2.4-34.1-3.5-69.4-3.3-104.7v-0.1v-0.1 c-0.1-35.3,1-70.5,3.3-104.6l0.1-1.1v-1.1c0-27.2,18.8-49.3,41.9-49.3H78l0.7,0c49.5-2.3,102.9-3.3,168.2-3.3h9H265 M265,64 c-3,0-6,0-9,0s-6,0-9,0c-57.6,0-114.2,0.8-169.6,3.3c-40.8,0-73.9,36.3-73.9,81.3C1,184.4-0.1,220,0,255.7c-0.1,35.7,0.9,71.3,3.4,107c0,45,33.1,81.6,73.9,81.6c54.8,2.6,110.7,3.8,167.8,3.8c3.6,0,7.3,0,10.9,0c3.6,0,7.2,0,10.7,0c57.1,0,113-1.2,167.9-3.8c40.9,0,74-36.6,74-81.6c2.4-35.7,3.5-71.4,3.4-107.1c0.1-35.7-1-71.3-3.4-107.1c0-45-33.1-81.1-74-81.1 C379.2,64.8,322.7,64,265,64L265,64z'%3E%3C/path%3E%3C/svg%3E");
          background-size: contain;
          opacity: 0.3;
          &.on {
            opacity: 1;
          }
          &::after {
            content: '';
            position: absolute;
            top: 0.425rem;
            left: 0.5rem;
            height: 0;
            width: 0;
            border: 0.2rem solid transparent;
            border-left-width: 0.4rem;
            border-left-color: $brn;
          }
        }
        .for-documents {
          position: absolute;
          top: 0.6rem;
          left: 0.75rem;
          transform: scale(0.25);
          transform-origin: top left;
          opacity: 0.4;
          pointer-events: none;
          &.on {
            opacity: 1;
          }
        }
      }
    }
  }
  .section-viewer-wrap {
    $blind-duration: 750ms;
    position: fixed;
    //top: 50vh;
    top: 4.25rem;
    left: 0;
    right: 0;
    height: calc(100vh - 4.25rem);
    //max-height: 0;
    overflow: hidden;
    pointer-events: none;
    transition: all $blind-duration ease-out;
    clip-path: inset(50% 10%);
    //clip-path: polygon(0% 0%, 0% 14.2857%, 14.2857% 14.2857%, 14.2857% 0%, 28.5714% 0%, 28.5714% 14.2857%, 42.8571% 14.2857%, 42.8571% 0%, 57.1428% 0%, 57.1428% 14.2857%, 71.4286% 14.2857%, 71.4286% 0%, 85.7143% 0%, 85.7143% 14.2857%, 100% 14.2857%, 100% 0%, 0% 0%, 0% 14.2857%, 14.2857% 14.2857%, 14.2857% 28.5714%, 28.5714% 28.5714%, 28.5714% 14.2857%, 42.8571% 14.2857%, 42.8571% 28.5714%, 57.1428% 28.5714%, 57.1428% 14.2857%, 71.4286% 14.2857%, 71.4286% 28.5714%, 85.7143% 28.5714%, 85.7143% 14.2857%, 0% 14.2857%, 0% 28.5714%, 0% 42.8571%, 14.2857% 42.8571%, 14.2857% 28.5714%, 28.5714% 28.5714%, 28.5714% 42.8571%, 42.8571% 42.8571%, 42.8571% 28.5714%, 57.1428% 28.5714%, 57.1428% 42.8571%, 71.4286% 42.8571%, 71.4286% 28.5714%, 85.7143% 28.5714%, 85.7143% 42.8571%, 100% 42.8571%, 100% 28.5714%, 0 28.5714%, 0% 42.8571%, 14.2857% 42.8571%, 14.2857% 57.1428%, 28.5714% 57.1428%, 28.5714% 42.8571%, 42.8571% 42.8571%, 42.8571% 57.1428%, 57.1428% 57.1428%, 57.1428% 42.8571%, 71.4286% 42.8571%, 71.4286% 57.1428%, 85.7143% 57.1428%, 85.7143% 42.8571%, 0% 42.8571%, 0% 71.4286%, 14.2857% 71.4286%, 14.2857% 57.1428%, 28.5714% 57.1428%, 28.5714% 71.4286%, 42.8571% 71.4286%, 42.8571% 57.1428%, 57.1428% 57.1428%, 57.1428% 71.4286%, 71.4286% 71.4286%, 71.4286% 57.1428%, 85.7143% 57.1428%, 85.7143% 71.4286%, 100% 71.4286%, 100% 57.1428%, 0% 57.1428%, 0% 71.4286%, 14.2857% 71.4286%, 14.2857% 85.7143%, 28.5714% 85.7143%, 28.5714% 71.4286%, 42.8571% 71.4286%, 42.8571% 85.7143%, 57.1428% 85.7143%, 57.1428% 71.4286%, 71.4286% 71.4286%, 71.4286% 85.7143%, 85.7143% 85.7143%, 85.7143% 71.4286%, 0% 71.4286%, 0% 85.7143%, 0% 100%, 14.2857% 100%, 14.2857% 85.7143%, 28.5714% 85.7143%, 28.5714% 100%, 42.8571% 100%, 42.8571% 85.7143%, 57.1428% 85.7143%, 57.1428% 100%, 71.4286% 100%, 71.4286% 85.7143%, 85.7143% 85.7143%, 85.7143% 100%, 100% 100%, 100% 85.7143%, 0% 85.7143%);
    z-index: 4;
    &.shown {
      //top: 4.25rem;
      //max-height: calc(100vh - 4.25rem);
      clip-path: inset(0 0 0 0);;
      pointer-events: all;
      & > .section-viewer {
        transform: translate3d(0, 0, 0);
      }
    }
    .section-viewer {
      position: absolute;
      top: 0;
      left: 0;
      //bottom: -50vh;
      bottom: 0;
      right: 0;
      //transform: translate3d(0, -50vh, 0);
      transition: all $blind-duration ease-out;
      will-change: transform;
      overflow: auto;
      background-color: $brn;
      padding-right: 18.25rem;
      &.pdf-mode {
        padding-right: 0.5rem;
        .widgets {
          .insights-documents {
            grid-template-columns: 1fr 4.5fr 1fr;
            &.wider-insights {
              grid-template-columns: 3fr 4.5fr 1fr;
            }
            .viewer {
              overflow: hidden;
              overflow-y: auto;
              grid-column: 2 / 3;
              grid-row: 1 / 3;
              height: calc(100vh - 5.25rem);
              /deep/ {
                .single {
                  height: 100%;
                  overflow: visible;
                  overflow-y: auto;
                  .pdf-cards {
                    height: 180vh;
                  }
                }
              }
            }
            .documents {
              display: block;
              margin-top: 2rem;
              grid-row: 1 / 3;
              & > .document {
                transform: translate3d(2.25rem, 0, 0);
                float: none;
              }
            }
          }
          .insights-publishers {
            margin-top: 0 !important;
            grid-row: 1 / 3 !important;
          }
          .videos {
            opacity: 0;
            pointer-events: none;
          }
        }
      }
      & > .title {
        position: fixed;
        top: 0.25rem;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        text-align: center;
        margin-left: -9.75rem;
        z-index: 100;
        box-sizing: border-box;
        padding: 0.25rem 0.5rem;
        background-color: rgba($brn, 0.8);
        border-bottom-left-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
        &.left {
          //margin-left: -12.75rem;
          margin-left: -9.75rem;
        }
        color: white;
        font-size: 2rem;
        font-weight: 500;
      }
      .widgets {
        &.has-videos {
          //padding-right: 12.75rem;
          .videos {
            //display: grid;
          }
        }
        .themes-section {
          //position: absolute;
          //top: 0;
          //left: 0;
          //right: 0;
          position: relative;
          top: 0;
          transform: translate3d(0, 4.85rem, 0);
          grid-column: 2 / 3;
          height: 11.75rem;
          margin: -2.2rem 0 -10rem;
          //background-color: lightskyblue;
          background-color: white;
          border-bottom: 6px solid rgba($brn, 0.5);
          z-index: 2;
          & > .title {
            text-align: left;
            margin-left: 0.5rem;
            text-transform: uppercase;
            line-height: 2rem;
            font-family: 'Assistant', sans-serif;
            font-size: 1.1rem;
            color: $brn;
          }
          .selected-themes {
            .selected-theme {
            }
          }
          & > .themes {
            position: absolute;
            left: 0;
            width: 100%;
            height: 9.5rem;
            display: flex;
            justify-content: flex-start;
            overflow: hidden;
            overflow-x: auto;
            .theme {
              cursor: pointer;
              position: relative;
              flex-shrink: 0;
              width: 5rem;
              height: 9.5rem;
              margin: 0;
              box-sizing: border-box;
              &.selected {
                .bg {
                  border-color: orange;
                }
              }
              &:first-of-type {
                margin-left: 0;
              }
              &:last-of-type {
                margin-right: 0;
              }
              //padding-top: 150%;
              //outline: 1px solid blue;
              &:hover {
                .title {
                  //opacity: 1;
                }
              }
              .title {
                cursor: default;
                position: absolute;
                bottom: 0.5rem;
                //left: -60%;
                //right: -60%;
                left: 0;
                right: 0;
                text-align: center;
                //font-size: 1.1rem;
                font-size: 0.8rem;
                //font-weight: 600;
                font-family: 'Assistant', sans-serif;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: $brn;
                //opacity: 0;
                //transition: opacity 250ms ease-in-out;
                z-index: 1;
                //border-radius: 0.5rem;
                background-color: rgba(white, 0.65);
                box-shadow: 0 0 3px white, 0 0 6px white;
                /*text-shadow: 1px 1px 0 white,
                             -1px -1px 0 white,
                             0 1px 0 white,
                             1px 0 0 white,
                             0 -1px 0 white,
                             -1px 0 1px white;*/
              }
              .bg {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 2rem;
                right: 0;
                background: white center no-repeat;
                //background-image: url('https://media.gettyimages.com/photos/pedestrian-crosses-a-bridge-in-front-novartis-ags-headquarters-in-picture-id137642112?b=1&k=6&m=137642112&s=612x612&w=0&h=qsND2vg0XhyJ72PcirzKiEB-wlynGpgvmtlSS_51EWI=');
                background-size: cover;
                border: 3px solid transparent;
              }
            }
          }
        }
        .insights-documents {
          display: grid;
          grid-row-gap: 1.2rem;
          padding: 0.5rem;
          grid-template-columns: 1fr 3fr;
          grid-template-rows: 12rem 1fr;
          grid-column-gap: 0.5rem;
          height: calc(100vh - 5.25rem);
          &.wider-insights {
            grid-template-columns: $split;
            .scroll-wrap {
              display: grid;
              grid-template-columns: $split;
              grid-column-gap: 0.75rem;
            }
            .wider-toggle {
              .wide {
                border-color: rgba($brn, 0.25);
                opacity: 1;
              }
            }
          }
          &:not(.wider-insights) {
            .wider-toggle {
              .skinny {
                border-color: rgba($brn, 0.25);
                opacity: 1;
              }
            }
          }
          & > .viewer {
            background-color: transparent;
          }
          .insights {
            position: relative;
            top: 1px;
            grid-row: 1 / 3;
            background-color: white;
            box-sizing: border-box;
            padding: 3rem 0.5rem 1rem 1.5rem;
            margin-top: 2.6rem;
            //border-top: 2.7rem solid $brn;
            height: calc(100% - 2.6rem);
            &.has-filters {
              & > .scroll-wrap {
                padding-top: 5.75rem;
              }
              & > .filter {
                top: 4rem;
              }
              & > .title {
                padding-bottom: 4.75rem;
              }
            }
            .wider-toggle {
              position: absolute;
              top: 0;
              right: 0;
              width: 4rem;
              height: 1.5rem;
              z-index: 1;
              display: grid;
              grid-template-columns: 3fr 7fr;
              grid-column-gap: 0.5rem;
              padding: 0.25rem;
              & > * {
                cursor: pointer;
                position: relative;
                border: 1px solid rgba($brn, 0.25);
                border-radius: 0.125rem;
                padding: 0.125rem;
                opacity: 0.5;
                .bar {
                  height: 0.25rem;
                  margin-bottom: 0.125rem;
                  background-color: rgba($brn, 0.5);
                }
              }
              .wide {
                &::after {
                  content: '';
                  position: absolute;
                  top: 0;
                  left: 50%;
                  bottom: 0;
                  margin-left: -0.125rem;
                  width: 0.25rem;
                  height: 100%;
                  background-color: white;
                }
              }
            }
            //overflow: auto;
            .scroll-wrap {
              position: absolute;
              top: 2rem;
              left: 0;
              right: 0;
              bottom: 0;
              overflow: auto;
              padding-top: 3.75rem;
              padding-left: 1.5rem;
              grid-auto-rows: min-content;
            }
            & > .max-age {
              cursor: pointer;
              position: absolute;
              top: 2.6rem;
              left: 0.5rem;
              right: 0.5rem;
              display: flex;
              justify-content: flex-start;
              z-index: 2;
              color: $brn;
              text-transform: uppercase;
              font-family: Assistant, Roboto, sans-serif;
              font-weight: 400;
              font-size: 0.75rem;
              .max-ages {
                position: absolute;
                top: -0.75rem;
                //left: -0.3rem;
                left: 0;
                width: 6rem;
                height: 0.5rem;
                z-index: 15;
                //background-color: mediumpurple;
                .age {
                  //cursor: pointer;
                  position: absolute;
                  top: 0.25rem;
                  left: 0;
                  height: 0.25rem;
                  //background-color: #ccc;
                  &.on {
                    background-color: orange;
                    &:after {
                      background-color: orange;
                    }
                  }
                  &:after {
                    position: absolute;
                    content: '';
                    top: -0.125rem;
                    left: 100%;
                    width: 0.125rem;
                    //height: 0.65rem;
                    height: 0.5rem;
                    border-radius: 0.125rem;
                    box-sizing: border-box;
                    //border: 1px solid $brn;
                    //background-color: $brn;
                    background-color: orange;
                    z-index: -1;
                  }
                }
              }
            }
            & > .filter {
              position: absolute;
              top: 2.5rem;
              left: 0.5rem;
              //width: 14rem;
              z-index: 2;
              label {
                input {
                  border: 1px solid #efefef;
                  line-height: 1.4rem;
                  padding-right: 1rem;
                  color: $brn;
                  &:focus {
                    border-color: #9a9a9a;
                    outline: none;
                  }
                }
              }
              .close {
                position: absolute;
                top: 0;
                right: 0.5rem;
                cursor: pointer;
              }
              .toggles {
                position: absolute;
                top: 0.125rem;
                left: 100%;
                margin-left: 0.5rem;
                display: grid;
                grid-template-columns: repeat(2, auto);
                & > * {
                  cursor: pointer;
                  font-family: 'Assistant', sans-serif;
                  font-size: 0.7rem;
                  text-transform: uppercase;
                  padding: 0.125rem 0.25rem;
                  border-radius: 0.25rem;
                  color: rgba($brn, 0.75);
                  border: 1px solid rgba($brn, 0.25);
                  &.on {
                    background-color: $brn;
                    border-color: $brn;
                    color: white;
                  }
                }
                .risk {
                  border-top-right-radius: 0;
                  border-bottom-right-radius: 0;
                }
                .opportunity {
                  border-top-left-radius: 0;
                  border-bottom-left-radius: 0;
                }
              }
            }
            & > .doc-types {
              position: absolute;
              top: 2.125rem;
              right: 0.5rem;
              width: 14rem;
              z-index: 2;
              //display: flex;
              //grid-auto-columns: 20%;
              display: grid;
              //justify-content: flex-start;
              grid-template-columns: 15rem;
              //grid-template-columns: repeat(6, 1.5rem);
              grid-column-gap: 0.125rem;
              grid-row-gap: 1.5rem;
              box-sizing: border-box;
              pointer-events: none;
              opacity: 0;
              transition: all 250ms ease-in-out;
              max-height: 0;
              padding: 1.5rem 0.5rem 0 0.25rem;
              overflow: hidden;
              //background-color: white;
              border: 1px solid transparent;
              border-radius: 0.25rem;
              //&.has-overflow:hover {
              &:hover {
                max-height: 100vh;
                border-color: #dadada;
                background-color: white;
                padding-bottom: 1.5rem;
                & > .doc-type {
                  pointer-events: all;
                  opacity: 0.5;
                  &.on {
                    opacity: 1;
                  }
                }
              }
              &.shown {
                pointer-events: all;
                opacity: 1;
              }
              & > .title {
                cursor: default;
                position: absolute;
                top: 0.25rem;
                left: 0.25rem;
                color: $brn;
                text-transform: capitalize;
                font-family: Assistant, Roboto, sans-serif;
                font-weight: 400;
                font-size: 0.9rem;
                &[resetable] {
                  cursor: pointer;
                  &::after {
                    content: '';
                    position: absolute;
                    bottom: 100%;
                    left: 100%;
                    transform: translate3d(-0.25rem, 0.25rem, 0);
                    width: 0.3rem;
                    height: 0.3rem;
                    border-radius: 50%;
                    background-color: orange;
                  }
                }
              }
              &::after {
                position: absolute;
                top: 0.45rem;
                right: 0.5rem;
                content: 'all types';
                color: $brn;
                text-transform: uppercase;
                font-family: Assistant, Roboto, sans-serif;
                font-weight: 400;
                font-size: 0.7rem;
              }
              &.has-selection {
                &::after {
                  content: attr(count) ' types selected';
                }
                &[count="1"]:after {
                  content: '1 type selected';
                }
                &:hover {
                  & > .doc-type {
                    &.on {
                      opacity: 1;
                      &::after {
                        opacity: 1;
                      }
                    }
                  }
                }
              }
              & > .doc-type {
                cursor: pointer;
                position: relative;
                //margin: 0 0.125rem;
                opacity: 0;
                padding-left: 2rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-align: left;
                pointer-events: none;
                font-family: Assistant, Roboto, sans-serif;
                &.on {
                  //opacity: 1;
                  &::after {
                    opacity: 0;
                  }
                }
                &:hover {
                  opacity: 1;
                }
                &::after {
                  content: '';
                  position: absolute;
                  top: 50%;
                  left: 1rem;
                  transform: translate3d(0, -50%, 0);
                  width: 0.45rem;
                  height: 0.45rem;
                  background-color: orange;
                  border-radius: 0.125rem;
                  opacity: 0;
                  transition: opacity 250ms ease-in-out;
                }
              }
            }
            & > .title {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              //position: fixed;
              //top: 3.5rem;
              //left: 1rem;
              box-sizing: border-box;
              padding: 0.25rem 0.5rem;
              padding-bottom: 2.75rem;
              background-color: white;
              border-radius: 0.5rem;
              z-index: 1;
              text-align: center;
              text-transform: capitalize;
              font-size: 1.4rem;
              font-weight: 500;
              white-space: nowrap;
              color: $brn;
            }
            .item-wrap {
              display: block;
              text-decoration: inherit !important;
              color: inherit !important;
              background-color: white;
              &.talking-flip-move {
                opacity: 0.25;
                transition: all 250ms ease-in-out;
              }
            }
            .no-results {
              position: absolute;
              top: 7rem;
              left: 0;
              right: 0;
              z-index: 5;
              font-weight: 200;
              font-size: 1.2rem;
              color: $brn;
              text-transform: uppercase;
            }
            .item {
              border: 1px solid #efefef;
              position: relative;
              text-align: left;
              cursor: pointer;
              //height: auto;
              height: 8.5rem;
              padding: 0.5rem 3rem 1rem 3rem;
              margin-bottom: 1.25rem;
              margin-right: 0.75rem;
              &:hover {
                & > .date {
                  opacity: 1;
                }
              }
              & > .copy {
                position: absolute;
                right: 0.5rem;
                top: -1rem;
              }
              & > .text {
                position: relative;
                max-height: 9.5rem;
                overflow: auto;
                //background: linear-gradient(0, white, rgba(green, 0) 20%) no-repeat;
                .keyword {
                  color: $brn;
                }
              }
              & > .publisher {
                position: absolute;
                bottom: 2.5rem;
                right: 0.5rem;
                & > .bg {
                  width: 2rem;
                  height: 2rem;
                  background: center white no-repeat;
                  background-size: contain;
                }
              }
              & > .document {
                position: absolute;
                top: -1rem;
                left: -1rem;
                padding: 0.125rem;
                border: 1px solid #ccc;
                & > .bg {
                  width: 3rem;
                  height: 4.25rem;
                  background: center white no-repeat;
                  background-size: contain;
                }
              }
              & > .date {
                pointer-events: none;
                position: absolute;
                bottom: 0.0625rem;
                right: 0.0625rem;
                padding: 0.125rem;
                background-color: rgba(255, 255, 255, 0.85);
                border-radius: 0.125rem;
                border: 1px solid #f9f9f9;
                font-size: 0.8rem;
                z-index: 4;
                opacity: 0;
                transition: opacity 250ms ease-in-out;
              }
            }
          }
          .documents {
            height: 100%;
            //background-color: red;
            //background-color: rgba(white, 0.7);
            //border: 4px solid rgba($brn, 0.25);
            //box-shadow: 0 0 6px rgba($brn, 0.1);
            //border-radius: 0.25rem;
            grid-row: 2 / 3;
            box-sizing: border-box;
            padding: 0.25rem;
            padding-top: 2.25rem;
            //margin-right: 2.1rem;
            //margin-bottom: 2rem;
            //display: flex;
            //flex-wrap: wrap;
            //justify-content: flex-start;
            //align-items: flex-start;
            overflow: auto;
            &.has-selection {
              .document {
                opacity: 0.75;
                &.selected {
                  border-color: orange;
                  opacity: 1;
                }
                &:hover {
                  opacity: 1;
                }
              }
            }
            .document {
              cursor: pointer;
              $height: 17.5rem;
              $width: 7 / 9 * $height;
              position: relative;
              width: $width;
              height: $height;
              margin: 0.25rem;
              float: left;
              //margin-right: 0;
              border: 0.25rem solid transparent;
              transition: all 250ms ease-in-out;
              &:hover {
                & > .date {
                  opacity: 1;
                }
                & > .magnifying-glass {
                  opacity: 1;
                  pointer-events: all;
                }
              }
              & > .title {
                position: absolute;
                bottom: 0;
                left: 0;
              }
              & > .bg {
                position: absolute;
                top: 0;
                left: 0;
                width: $width;
                height: $height;
                background: no-repeat center white;
                background-size: contain;
              }
              & > .date {
                position: absolute;
                left: 0;
                //right: 0;
                bottom: 0;
                border-top-right-radius: 0.25rem;
                box-sizing: border-box;
                padding: 0.125rem 0.5rem;
                color: $brn;
                font-family: 'Assistant', sans-serif;
                font-size: 0.8rem;
                background-color: white;
                text-align: left;
                opacity: 0;
                pointer-events: none;
                transition: opacity 250ms ease-in-out;
              }
            }
          }
          & > .themes-full-section {
            user-select: none;
            padding-top: 9rem;
            transform: translate3d(0, 2.7rem, 0);
            background-color: white;
            height: calc(100vh - 11.95rem);
            overflow: hidden;
            overflow-y: auto;
            .selected-themes {
              position: absolute;
              top: 1rem;
              left: 2rem;
              right: 1rem;
              display: flex;
              transition: transform 250ms ease-in-out 250ms;
              &.nudge-right {
                transform: translate3d(0.9rem, 0, 0);
              }
              padding-left: 0;
              & > .and-or {
                cursor: pointer;
                position: absolute;
                top: 0.35rem;
                left: -2.65rem;
                color: $brn;
                border: 1px solid rgba($brn, 0.5);
                border-radius: 0.25rem;
                width: 2.25rem;
                font-size: 0.8rem;
                font-family: Assistant, Roboto, sans-serif;
                text-transform: uppercase;
                text-align: center;
                opacity: 0;
                pointer-events: none;
                transition: opacity 250ms ease-in-out 250ms;
              }
              .selected-theme {
                position: relative;
                width: 4.21875rem;
                height: 6.890625rem;
                box-sizing: border-box;
                margin-right: 0.5rem;
                & + .selected-theme + .and-or {
                  opacity: 0.5;
                  pointer-events: all;
                  &.on {
                    opacity: 1;
                  }
                }
                .bg {
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  background: white center no-repeat;
                  background-size: cover;
                  border: 3px solid orange;
                  //background-color: lightskyblue;
                }
              }
            }
            & > .filter {
              position: relative;
              width: 12rem;
              margin: 0 0 0.25rem 1.125rem;

              label {
                input {
                  border: 1px solid #efefef;
                  line-height: 1.4rem;
                  padding-right: 1rem;
                  color: $brn;
                  &:focus {
                    border-color: #9a9a9a;
                    outline: none;
                  }
                }
              }
              .close {
                position: absolute;
                top: 0;
                right: 1rem;
                cursor: pointer;
              }
              & > .filter-toggle {
                cursor: pointer;
                position: absolute;
                top: 0;
                left: 100%;
                width: 1.5rem;
                height: 1.5rem;
                margin-left: -0.5rem;
                background: no-repeat center
                  url("data:image/svg+xml;charset%3Dutf8,%3C?xml version%3D'1.0' encoding%3D'UTF-8'?%3E%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'-2 -256 1792 1792'%3E%3Cg transform%3D'matrix(1,0,0,-1,182.23729,1201.8983)'%3E%3Cpath style%3D'fill:%238d6e4f;' d%3D'm 1403,1241 q 17,-41 -14,-70 L 896,678 V -64 q 0,-42 -39,-59 -13,-5 -25,-5 -27,0 -45,19 L 531,147 q -19,19 -19,45 V 678 L 19,1171 q -31,29 -14,70 17,39 59,39 h 1280 q 42,0 59,-39 z'/%3E  %3C/g%3E%3C/svg%3E");
                background-size: 100%;
                opacity: 0.5;
                transition: opacity 250ms ease-in-out;
                &:hover,
                &.selected {
                  opacity: 1;
                }
                .parent {
                  position: absolute;
                  top: 0.25rem;
                  left: 100%;
                  margin-left: 0.25rem;
                  font-family: 'Assistant', sans-serif;
                  font-size: 0.7rem;
                  text-transform: uppercase;
                  color: $brn;
                  opacity: 0;
                  pointer-events: none;
                  transition: opacity 250ms ease-in-out;
                  &.shown {
                    opacity: 1;
                    pointer-events: all;
                  }
                }
              }
            }
            .items {
              background-color: white;
              border-left: 2rem solid white;
              //float: left;
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              overflow: hidden;
              overflow-y: auto;
              box-sizing: border-box;
              //padding-top: 2rem;
              padding-bottom: 8rem;
              &:hover {
                .item {
                  .filter-toggle {
                    opacity: 1;
                    pointer-events: all;
                  }
                  .border {
                    opacity: 1;
                  }
                  .has-polar .polar:hover {
                    background-color: white;
                    .wedge {
                      opacity: 1;
                    }
                    .rings {
                      opacity: 0;
                      pointer-events: none;
                    }
                  }
                }
              }
              &.show-wedges {
                .item {
                  .border {
                    opacity: 1;
                  }
                  .has-polar .polar {
                    background-color: white;
                    &:hover {
                      & + .legends {
                        opacity: 1;
                      }
                    }
                    .wedge {
                      opacity: 1;
                    }
                    .rings {
                      opacity: 0;
                      pointer-events: none;
                    }
                  }
                }
              }
              .item {
                cursor: pointer;
                position: relative;
                flex-shrink: 0;
                width: 7.5rem;
                height: 14.25rem;
                margin: 0 0.25rem;
                box-sizing: border-box;
                &.selected {
                  .bg {
                    border-color: orange;
                  }
                }
                &:first-of-type {
                  margin-left: 0;
                }
                &:last-of-type {
                  margin-right: 0;
                }
                &.theme-tile-flip-leave-active,
                &.theme-tile-flip-move {
                  opacity: 0.25 !important;
                  //max-width: 0;
                  transition-duration: 500ms;
                }
                //&:nth-child(even) {
                //  top: 4rem;
                //}
                //padding-top: 150%;
                //outline: 1px solid blue;
                &:hover {
                  .title {
                    //opacity: 1;
                  }
                }
                .filter-toggle {
                  position: absolute;
                  top: 0.2rem;
                  left: 0.3rem;
                  width: 1.2rem;
                  height: 1.2rem;
                  opacity: 0;
                  pointer-events: none;
                  transition: opacity 250ms ease-in-out;
                  &::before {
                    pointer-events: none;
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 0;
                    width: 0;
                    border: 1.75rem solid transparent;
                    border-right-color: white;
                    transform: translate3d(-2rem, -1.7rem, -1px) rotate(45deg);
                    //z-index: -1;
                  }
                  &::after {
                    content: '';
                    position: absolute;
                    top: 0.25rem;
                    left: -0.25rem;
                    bottom: -0.25rem;
                    right: 0.25rem;
                    background: no-repeat center
                      url("data:image/svg+xml;charset%3Dutf8,%3C?xml version%3D'1.0' encoding%3D'UTF-8'?%3E%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'-2 -256 1792 1792'%3E%3Cg transform%3D'matrix(1,0,0,-1,182.23729,1201.8983)'%3E%3Cpath style%3D'fill:%238d6e4f;' d%3D'm 1403,1241 q 17,-41 -14,-70 L 896,678 V -64 q 0,-42 -39,-59 -13,-5 -25,-5 -27,0 -45,19 L 531,147 q -19,19 -19,45 V 678 L 19,1171 q -31,29 -14,70 17,39 59,39 h 1280 q 42,0 59,-39 z'/%3E  %3C/g%3E%3C/svg%3E");
                    background-size: 100%;
                    opacity: 0.5;
                    transition: opacity 250ms ease-in-out;
                    transform: translate3d(0, 0, 1px);
                    z-index: 1;
                  }
                  &:hover,
                  &.selected {
                    &::after {
                      opacity: 1;
                    }
                  }
                }
                .title {
                  cursor: default;
                  position: absolute;
                  bottom: 0.5rem;
                  //left: -60%;
                  //right: -60%;
                  left: 0;
                  right: 0;
                  text-align: center;
                  //font-size: 1.1rem;
                  font-size: 0.8rem;
                  //font-weight: 600;
                  font-family: 'Assistant', sans-serif;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  color: $brn;
                  //opacity: 0;
                  //transition: opacity 250ms ease-in-out;
                  z-index: 1;
                  //border-radius: 0.5rem;
                  background-color: rgba(white, 0.65);
                  box-shadow: 0 0 3px white, 0 0 6px white;
                  /*text-shadow: 1px 1px 0 white,
                               -1px -1px 0 white,
                               0 1px 0 white,
                               1px 0 0 white,
                               0 -1px 0 white,
                               -1px 0 1px white;*/
                }
                .bg {
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 2rem;
                  right: 0;
                  background: white center no-repeat;
                  background-image: url('https://media.gettyimages.com/photos/pedestrian-crosses-a-bridge-in-front-novartis-ags-headquarters-in-picture-id137642112?b=1&k=6&m=137642112&s=612x612&w=0&h=qsND2vg0XhyJ72PcirzKiEB-wlynGpgvmtlSS_51EWI=');
                  background-size: cover;
                  border: 3px solid transparent;
                }
                & > .tile {
                  &.has-polar {
                    & > .bg {
                      overflow: hidden;
                    }
                    .glare {
                      position: absolute;
                      top: 0;
                      left: -20rem;
                      right: -10rem;
                      height: 1rem;
                      background-color: rgba(white, 0.55);
                      box-shadow: 0 0.125rem 1rem rgba(white, 0.5);
                      &.on {
                        display: block;
                        //transform: rotate(-30deg);
                        animation: skim 4s infinite;
                      }
                      @keyframes skim {
                        0% {
                          transform: rotate(-30deg) translate3d(0, -4rem, 0);
                        }
                        5% {
                          transform: rotate(-30deg) translate3d(0, 2rem, 0);
                        }
                        20% {
                          transform: rotate(-30deg) translate3d(0, 16rem, 0);
                        }
                        //20% {
                        //transform: rotate(-30deg) translate3d(6rem, 6rem, 0);
                        //}
                        //50% {
                        //  transform: rotate(-30deg) translate3d(16rem);
                        //}
                        100% {
                          transform: rotate(-50deg) translate3d(0, 40rem, 0);
                        }
                      }
                    }
                    & > .bg {
                      transform: scale(1);
                    }
                  }
                  .glare {
                    display: none;
                  }
                  & > .polar {
                    cursor: pointer;
                    position: absolute;
                    top: -1.85rem;
                    right: -2rem;
                    //top: 2.5rem;
                    //right: 2rem;
                    width: 4.125rem;
                    height: 4.125rem;
                    border-radius: 50%;
                    clip-path: inset(50% 50% 0 0);
                    transform: scale(0.75);
                    transition: all 250ms ease-in-out;
                    z-index: 1;
                    &:hover {
                      transform: scale(1.2);
                    }
                    &::after {
                      content: '';
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      width: 1.125rem;
                      height: 1.125rem;
                      transform: translate3d(-50%, -50%, 1px);
                      background-color: white;
                      box-sizing: border-box;
                      border: 0.25rem solid white;
                      border-radius: 50%;
                    }
                    & + .legends {
                      position: absolute;
                      top: 1rem;
                      right: 0;
                      pointer-events: none;
                      z-index: 5;
                      opacity: 0;
                      transition: opacity 250ms ease-in-out;
                      & > .legend {
                        position: absolute;
                        top: -0.9rem;
                        right: 2rem;
                        white-space: nowrap;
                        text-transform: uppercase;
                        font-size: 0.5rem;
                        font-family: 'Assistant', sans-serif;
                        padding: 0.25rem;
                        border-radius: 0.125rem;
                        background-color: white;
                        box-shadow: 0 0 1px $brn;
                        &.insights-legend {
                          top: 0.5rem;
                          right: 1.85rem;
                        }
                        &.risk-legend {
                          top: 2rem;
                          right: -1rem;
                        }
                      }
                    }
                    & > .border {
                      pointer-events: none;
                      position: absolute;
                      top: 1.65rem;
                      left: 0;
                      bottom: 0;
                      right: 50%;
                      box-sizing: border-box;
                      border: 1px solid #dadada;
                      border-bottom-left-radius: 100%;
                      z-index: 2;
                      opacity: 0;
                      transition: opacity 250ms ease-in-out;
                      overflow: hidden;
                    }
                    .rings {
                      //pointer-events: none;
                      position: absolute;
                      top: 0;
                      left: 0;
                      right: 0;
                      bottom: 0;
                      margin-top: -0.5rem;
                      border-radius: 100%;
                      box-sizing: border-box;
                      clip-path: inset(50% 50% 0 0);
                      transition: opacity 250ms ease-in-out;
                      z-index: 2;
                      &.hide {
                        opacity: 0;
                        pointer-events: none;
                      }
                      & .ring {
                        position: absolute;
                        top: 0.25rem;
                        left: 0.25rem;
                        right: 0.25rem;
                        bottom: 0.25rem;
                        border-radius: 100%;
                        border: 1px solid transparent;
                        &.on {
                          background-color: orange;
                          border-color: white;
                        }
                      }
                    }
                    .wedge {
                      position: absolute;
                      top: 0;
                      left: 0;
                      bottom: 0;
                      right: 0;
                      box-sizing: border-box;
                      border: 0.25rem solid white;
                      //border: 1px solid blue;
                      //border-top-color: black;
                      border-radius: 50%;
                      //transform-origin: bottom right;
                      transform: rotate(-72deg);
                      overflow: hidden !important;
                      //outline: 1px solid black;
                      opacity: 0;
                      transition: opacity 250ms ease-in-out;
                      svg {
                        opacity: 0.8;
                        position: absolute;
                        bottom: 50%;
                        right: 50%;
                        transform: rotate(-45deg) scale(5) translate3d(0.75px, -1.125px, 0);
                        //border: 1px solid black;
                      }
                      & + .wedge {
                        transform: rotate(-104deg);
                        svg {
                          transform: rotate(-45deg) scale(5) translate3d(0.5px, -2.125px, 0);
                          //transform: rotate(-149deg) translate3d(11.75rem, -9.125rem, 0);
                        }
                        & + .wedge {
                          transform: rotate(-135deg);
                          svg {
                            transform: rotate(-45deg) scale(5) translate3d(0, -1.5px, 0);
                            //transform: rotate(-180deg) translate3d(28.75rem, -2.6rem, 0);
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          .insights-publishers {
            position: relative;
            grid-row: 2 / 3;
            box-sizing: border-box;
            padding: 0.5rem;
            padding-top: 5.5rem;
            padding-bottom: 5.5rem;
            //margin-top: 12.25rem;
            background-color: white;
            border-top: 2.7rem solid $brn;
            overflow: hidden;
            overflow-y: auto;
            //display: grid;
            //grid-template-columns: repeat(7, 3rem);
            //display: flex;
            //flex-wrap: wrap;
            //justify-content: flex-start;
            //align-items: flex-start;
            //grid-gap: 0.25rem;
            //grid-gap: 3rem;
            z-index: 1;
            &.has-selection {
              .selected-insights-publishers {
                border-bottom-color: orange;
              }
              .insights-publisher {
                opacity: 0.5;
                &.selected {
                  border-color: orange;
                  opacity: 1;
                }
                &:hover {
                  opacity: 1;
                }
              }
            }
            &.show-badges {
              .insights-publisher {
                .badges {
                  transition: all 250ms ease-in-out;
                  transform: none;
                  //opacity: 1;
                  //pointer-events: all;
                }
              }
            }
            .pub-filters {
              user-select: none;
              position: absolute;
              top: 0.5rem;
              right: 0.5rem;
              z-index: 2;
              display: grid;
              grid-template-columns: 4.25rem 1.65rem 4rem 3rem 10.25rem;
              grid-row-gap: 0.25rem;
              & > .sectors-filters-section {
                user-select: none;
                z-index: 1;
                grid-row: 1 / 4;
                position: relative;
                //right: 17.75rem;
                height: 4rem;
                //font-size: 0.5rem;
                &:hover,
                &.has-selection {
                  .sector {
                    background-color: rgba($brn, 0.25);
                    &:hover {
                      background-color: rgba($brn, 0.5);
                    }
                    &.selected {
                      background-color: $brn;
                    }
                  }
                }
                .sector {
                  position: relative;
                  cursor: crosshair;
                  width: 1.125rem;
                  min-height: 2px;
                  background-color: rgba($brn, 0.5);
                  box-sizing: border-box;
                  border-radius: 2px;
                  margin-bottom: 3px;
                  transition: background-color 125ms ease-in-out;
                  &:hover > .info {
                    opacity: 1;
                  }
                  & > .info {
                    pointer-events: none;
                    position: absolute;
                    top: 50%;
                    left: 100%;
                    margin-left: 0.25rem;
                    background-color: $brn;
                    color: white;
                    padding: 0.25rem 0.5rem;
                    border-radius: 0.25rem;
                    white-space: nowrap;
                    transition: opacity 250ms ease-in-out 300ms;
                    font-family: 'Assistant', sans-serif;
                    font-size: 0.8rem;
                    opacity: 0;
                  }
                }
              }
              & > .styles-wrap {
                grid-row: 1 / 4;
              }
              & > .percent-of-fund {
                grid-row: 1 / 4;
                //position: absolute;
                //right: 100%;
                //bottom: 0;
                //white-space: nowrap;
                transform: translate3d(-0.5rem, 0, 0);
                /deep/ .center {
                  font-family: 'Assistant', sans-serif;
                  transform-origin: center;
                  transform: scale(4) translate3d(0.125rem, -0.06125rem, 0);
                  color: $brn;
                  .decimals {
                    display: inline-block;
                    transform-origin: left bottom;
                    transform: scale(0.6) translate3d(0, -1px, 0);
                  }
                }
              }
              & > .regions {
                //position: relative;
                //left: -2rem;
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                grid-row: 1 / 4;
                grid-gap: 0.06125rem;
                padding-right: 0.5rem;
                & > .region {
                  cursor: pointer;
                  text-transform: uppercase;
                  font-size: 0.7rem;
                  font-family: 'Assistant', sans-serif;
                  color: $brn;
                  text-decoration: line-through;
                  opacity: 0.3;
                  border: 1px solid white;
                  border-radius: 0.25rem;
                  transition: all 250ms ease-in-out;
                  &.has-value {
                    text-decoration: none;
                    opacity: 0.5;
                    border: 1px solid rgba($brn, 0.46);
                    &.selected {
                      opacity: 1;
                      border: 1px solid $brn;
                      background-color: $brn;
                      color: white;
                    }
                  }
                }
              }
              & > .pays {
                cursor: pointer;
                grid-row: 2 / 3;
                border-radius: 50%;
                box-sizing: border-box;
                font-weight: 600;
                padding-top: 0.06125rem;
                padding-right: 0.06125rem;
                //padding-bottom: 0.25rem;
                font-size: 0.95rem;
                width: 1.75rem;
                height: 1.75rem;
                border: 1px solid rgba($brn, 0.46);
                color: $brn;
                font-family: 'Assistant', sans-serif;
                opacity: 0.5;
                transition: all 250ms ease-in-out;
                //&:hover,
                &.on {
                  border-color: $brn;
                  opacity: 1;
                }
              }
              & > .is-new {
                cursor: pointer;
                border-radius: 0.25rem;
                box-sizing: border-box;
                //font-weight: 600;
                //padding-right: 0.06125rem;
                //padding-bottom: 0.25rem;
                font-size: 0.75rem;
                width: 2.75rem;
                height: 1.125rem;
                text-transform: uppercase;
                //padding-top: 1px;
                padding-bottom: 2px;
                border: 1px solid rgba($brn, 0.46);
                color: $brn;
                font-family: 'Assistant', sans-serif;
                opacity: 0.5;
                transition: all 250ms ease-in-out;
                //&:hover,
                &.on {
                  border-color: $brn;
                  opacity: 1;
                }
              }
            }
            .selected-insights-publishers {
              position: absolute;
              top: 0.5rem;
              left: 0.5rem;
              right: 0.5rem;
              box-sizing: border-box;
              height: 4.5rem;
              //padding-bottom: 0.5rem;
              border-bottom: 2px solid transparent;
              transition: all 250ms ease-in-out;
              .insights-publisher {
                opacity: 1;
                &.selected-pub-flip-leave-active,
                &.selected-pub-flip-move {
                  opacity: 0.25 !important;
                  //max-width: 0;
                  transition: all 500ms ease-in-out;
                }
              }
            }
            .insights-publisher {
              cursor: pointer;
              user-select: none;
              float: left;
              //align-self: flex-start;
              position: relative;
              box-sizing: border-box;
              width: 3.5rem;
              height: 3.5rem;
              margin: 0.25rem;
              //padding-top: 100%;
              border: 0.25rem solid transparent;
              transition: all 250ms ease-in-out;
              &:hover {
                .badges {
                  transform: none;
                  pointer-events: all;
                }
              }
              &.pub-flip-leave-active,
              &.pub-flip-move {
                opacity: 0.25 !important;
                //max-width: 0;
                transition-duration: 500ms;
              }
              &.big {
                width: 8rem;
                height: 8rem;
                margin: 0.4rem;
                margin-right: 1.25rem;
              }
              //&[size]::before,
              .cap-style {
                cursor: pointer;
                display: inline-block;
                border-radius: 50%;
                width: 1rem;
                height: 1rem;
                transform-origin: center;
                background-color: #f1f1f1;
                z-index: 2;
              }
              &[size="large"] {
                & .cap-style {
                  transform: scale(0.9);
                }
              }
              &[size="mid"] {
                & .cap-style {
                  transform: scale(0.6);
                }
              }
              &[size="small"] {
                & .cap-style {
                  transform: scale(0.5);
                }
              }
              &[kind="value"] {
                & .cap-style {
                  background-color: rgba($brn, 0.467);
                }
              }
              &[kind="core"] {
                & .cap-style {
                  background-color: #dadada;
                }
              }
              &[kind="growth"] {
                & .cap-style {
                  background-color: orange;
                }
              }
              & > .badges {
                position: absolute;
                top: 0;
                right: -1.5rem;
                z-index: 2;
                //height: 3rem;
                //visibility: hidden;
                //pointer-events: none;
                transition: all 250ms ease-in-out 750ms;
                transform: rotate3d(0, 1, 0, -90deg);
                transform-origin: left center;
                & > * {
                  width: 1.06125rem;
                  height: 1.06125rem;
                }
                & > .pays {
                  font-weight: 600;
                  transform: translate3d(0.5rem, 0, 0) scale(0.9);
                  color: $brn;
                  font-size: 0.8rem;
                  box-sizing: border-box;
                  border-radius: 50%;
                  border: 1px solid $brn;
                  opacity: 0.1;
                  //transform: translate3d(0, 0.5rem, 0);
                  &.on {
                    opacity: 1;
                    //padding-top: 0.125rem;
                  }
                }
                & > .region {
                  //font-weight: 600;
                  //transform: translate3d(0.5rem, 0, 0) scale(0.9);
                  color: $brn;
                  font-size: 0.65rem;
                  box-sizing: border-box;
                  text-transform: uppercase;
                  transform: translate3d(0.6rem, 0.25rem, 0);
                }
                .is-new {
                  //font-weight: 600;
                  //transform: scale(0.9);
                  //color: $brn;
                  text-transform: uppercase;
                  font-size: 0.5rem;
                  font-family: 'Assistant', sans-serif;
                  box-sizing: border-box;
                  //padding-top: 1px;
                  border-radius: 0.125rem;
                  border: 1px solid $brn;
                  height: 0.75rem;
                  width: 2rem;
                  transform: translate3d(0.5rem, 0, 0);
                  margin-bottom: 0.5rem;
                  opacity: 0.1;
                  &.on {
                    opacity: 1;
                    //padding-top: 0.125rem;
                  }
                }
                .percentage {
                  position: absolute;
                  top: 4.2rem;
                  left: 0;
                  font-family: 'Assistant', sans-serif;
                  font-size: 0.7rem;
                  box-sizing: border-box;
                  width: auto;
                  padding: 0.125rem 0.25rem;
                  border-radius: 0.125rem;
                  background-color: white;
                  padding-top: 1px;
                  transform: translate3d(0.5rem, 0.5rem, 0);
                }
              }
              .bg {
                position: absolute;
                top: 0.125rem;
                left: 0.125rem;
                bottom: 0.125rem;
                right: 0.125rem;
                background: no-repeat center;
                background-size: contain;
              }
            }
          }
        }
        .videos {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          width: 17.75rem;
          background-color: white;
          padding: 0.25rem;
          padding-top: 4rem;
          //display: none;
          display: grid;
          grid-row-gap: 0.25rem;
          height: calc(100vh - 9rem);
          overflow: auto;
          transition: opacity 250ms ease-in-out;
          & > .title {
            position: absolute;
            top: 2.5rem;
            left: 0;
            right: 0;
            text-align: center;
            text-transform: capitalize;
            font-size: 1.4rem;
            font-weight: 500;
            white-space: nowrap;
            color: $brn;
          }
          a.video {
            position: relative;
            display: inline-block;
            //width: 22%;
            padding-top: 1.35%;
            margin: 1rem 1.5%;
            transition: transform 250ms ease-in-out;
            will-change: transform;
            &:not([draggable="true"]):hover {
              z-index: 3;
              .bg {
                transform: translate3d(0, 95%, 0);
              }
              .info {
                opacity: 1;
              }
            }
            &.playing {
              .bg {
                &::after {
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  content: '\00a0';
                  background: rgba(40, 40, 40, 0.4) center no-repeat
                  url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in' viewBox%3D'0 0 6.827 6.827' width%3D'6.827in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'white' d%3D'M2.83373 4.08723c0.234571,-0.12152 0.468327,-0.242677 0.702075,-0.363862 0.229406,-0.118933 0.458823,-0.237913 0.689008,-0.357299 -0.255059,-0.133181 -0.508724,-0.265543 -0.762114,-0.397764 -0.209614,-0.109378 -0.419059,-0.218677 -0.628969,-0.328256l0 1.44718zm0.750823 -0.26928c-0.259551,0.134563 -0.51911,0.269091 -0.779783,0.404118l-0.0777087 0.040252 0 -0.0875433 0 -1.62249 0 -0.0877638 0.0779173 0.0406811c0.236012,0.123224 0.471343,0.246024 0.706886,0.368933 0.283362,0.147858 0.567059,0.295898 0.852677,0.445059l0.0905591 0.0472953 -0.0907677 0.0470787c-0.260673,0.135205 -0.520232,0.269819 -0.77978,0.404378z'/%3E%3Cpath fill%3D'white' d%3D'M5.83278 4.58511c-0.0327126,0.14115 -0.106701,0.263898 -0.20726,0.355248 -0.101142,0.091874 -0.229165,0.152126 -0.369209,0.16763 -0.305,0.0341142 -0.612587,0.0512874 -0.921185,0.0598937 -0.306618,0.00855118 -0.614535,0.00855118 -0.921929,0.00837402 -0.307256,0.000177165 -0.615177,0.000177165 -0.921839,-0.00837402 -0.308642,-0.0086063 -0.616319,-0.0257795 -0.921354,-0.0598937 -0.140071,-0.0155039 -0.268122,-0.0757756 -0.36922,-0.167677 -0.100508,-0.0913583 -0.174394,-0.214094 -0.206894,-0.355201 -0.0436378,-0.189098 -0.0654331,-0.386354 -0.0763071,-0.584752 -0.0109252,-0.199445 -0.0109291,-0.395992 -0.0109291,-0.586795 0,-0.191055 0.000279528,-0.387858 0.0114685,-0.587185 0.0111457,-0.198484 0.0332087,-0.395748 0.0768228,-0.584815 0.0323071,-0.141047 0.106157,-0.263748 0.206673,-0.35511 0.101157,-0.0919528 0.229335,-0.15226 0.369445,-0.167764 0.304996,-0.0341181 0.612673,-0.0512913 0.921315,-0.0599016 0.306665,-0.00855118 0.614587,-0.00855118 0.921799,-0.00837402 0.307256,-0.000177165 0.615197,-0.000177165 0.921823,0.00837402 0.308606,0.00861024 0.616193,0.0257835 0.921016,0.0599016 0.140244,0.0154961 0.268476,0.0757756 0.369728,0.167689 0.100626,0.0913504 0.174594,0.214075 0.207094,0.355185 0.0859488,0.37402 0.0859488,0.779492 0.0859409,1.16233l0.000208661 0 0 0.00967323 -0.000208661 0c1.5748e-005,0.192681 -7.48031e-005,0.391154 -0.0108425,0.586795 -0.0109134,0.19839 -0.0327126,0.395646 -0.0761575,0.584752zm-0.278929 0.2765c0.0849961,-0.0772126 0.147535,-0.180961 0.175181,-0.300248 0.0419449,-0.182579 0.0630433,-0.373945 0.0736535,-0.566839 0.0107638,-0.19563 0.0108543,-0.391161 0.0108425,-0.580961l-0.000208661 0 0 -0.00967323 0.000208661 0c3.93701e-006,-0.376594 7.87402e-006,-0.775457 -0.083437,-1.13858 -0.0274685,-0.119264 -0.0899803,-0.222992 -0.175016,-0.300185 -0.0849213,-0.0770866 -0.19235,-0.12763 -0.309728,-0.140602 -0.30328,-0.0339488 -0.607673,-0.0509882 -0.91226,-0.0594843 -0.306567,-0.00854724 -0.613094,-0.00854724 -0.918909,-0.00837402 -0.305772,-0.000173228 -0.61228,-0.000173228 -0.918886,0.00837402 -0.304618,0.00849606 -0.609102,0.0255394 -0.912559,0.0594843 -0.117224,0.0129724 -0.224587,0.0635433 -0.309445,0.140677 -0.0848898,0.0771614 -0.14728,0.180858 -0.174594,0.30011 -0.0421299,0.182626 -0.0634843,0.373984 -0.0743189,0.566902 -0.0107835,0.192075 -0.0110512,0.389496 -0.0110512,0.58135 0,0.191677 0,0.38913 0.0105118,0.580961 0.0105709,0.192882 0.0316654,0.384244 0.0738031,0.566839 0.0274724,0.119291 0.0899055,0.22302 0.174815,0.300201 0.0847992,0.0770866 0.192043,0.127618 0.30922,0.140591 0.303492,0.0339449 0.607976,0.0509843 0.912598,0.0594764 0.306602,0.00854724 0.61311,0.00854724 0.918925,0.00837402 0.305953,0.000173228 0.612457,0.000173228 0.919016,-0.00837402 0.304579,-0.00849213 0.608972,-0.0255354 0.912429,-0.0594764 0.117157,-0.0129724 0.224382,-0.0634882 0.309209,-0.140543z'/%3E%3C/svg%3E");
                  background-size: 8rem;
                }
              }
            }
            .bg {
              will-change: transform;
              transition: transform 250ms ease-in-out;
              transform: translate3d(0, 0, 0);
              border-radius: 3px;
              box-shadow: 0 0 5px #989898, 0 0 15px #989898;
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              background: white no-repeat center;
              background-size: cover;
              .duration {
                position: absolute;
                bottom: 0.5rem;
                left: 3rem;
                color: white;
                text-shadow: 1px 1px 1px #black,
                -1px -1px 1px #black,
                -1px 1px 1px #black,
                1px -1px 1px #black
                1px 1px 1px #black,
                -1px -1px 1px #black,
                -1px 1px 1px #black,
                1px -1px 1px #black;

              }
              .source {
                position: absolute;
                left: 0.5rem;
                bottom: 0.5rem;
                height: 2rem;
                width: 2rem;
                background: no-repeat center;
                background-size: contain;
                border-radius: 50%;
              }
            }
            .info {
              box-sizing: border-box;
              padding: 0.25rem;
              border: 1px solid #ccc;
              border-radius: 4px;
              opacity: 0;
              will-change: opacity;
              transition: opacity 250ms ease-in-out;
              z-index: -1;
              position: absolute;
              top: 0.5rem;
              left: 0.5rem;
              bottom: 0.5rem;
              right: 0.5rem;
              .bap {
                cursor: pointer;
                position: absolute;
                bottom: 3rem;
                left: 0;
                right: 0;
                height: 5rem;
                background: no-repeat center bottom
                url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in'  viewBox%3D'0 0 6.827 6.827' width%3D'6.827in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'%238d6e4f' d%3D'M2.83373 4.08723c0.234571,-0.12152 0.468327,-0.242677 0.702075,-0.363862 0.229406,-0.118933 0.458823,-0.237913 0.689008,-0.357299 -0.255059,-0.133181 -0.508724,-0.265543 -0.762114,-0.397764 -0.209614,-0.109378 -0.419059,-0.218677 -0.628969,-0.328256l0 1.44718zm0.750823 -0.26928c-0.259551,0.134563 -0.51911,0.269091 -0.779783,0.404118l-0.0777087 0.040252 0 -0.0875433 0 -1.62249 0 -0.0877638 0.0779173 0.0406811c0.236012,0.123224 0.471343,0.246024 0.706886,0.368933 0.283362,0.147858 0.567059,0.295898 0.852677,0.445059l0.0905591 0.0472953 -0.0907677 0.0470787c-0.260673,0.135205 -0.520232,0.269819 -0.77978,0.404378z'/%3E%3Cpath fill%3D'%238d6e4f' d%3D'M5.83278 4.58511c-0.0327126,0.14115 -0.106701,0.263898 -0.20726,0.355248 -0.101142,0.091874 -0.229165,0.152126 -0.369209,0.16763 -0.305,0.0341142 -0.612587,0.0512874 -0.921185,0.0598937 -0.306618,0.00855118 -0.614535,0.00855118 -0.921929,0.00837402 -0.307256,0.000177165 -0.615177,0.000177165 -0.921839,-0.00837402 -0.308642,-0.0086063 -0.616319,-0.0257795 -0.921354,-0.0598937 -0.140071,-0.0155039 -0.268122,-0.0757756 -0.36922,-0.167677 -0.100508,-0.0913583 -0.174394,-0.214094 -0.206894,-0.355201 -0.0436378,-0.189098 -0.0654331,-0.386354 -0.0763071,-0.584752 -0.0109252,-0.199445 -0.0109291,-0.395992 -0.0109291,-0.586795 0,-0.191055 0.000279528,-0.387858 0.0114685,-0.587185 0.0111457,-0.198484 0.0332087,-0.395748 0.0768228,-0.584815 0.0323071,-0.141047 0.106157,-0.263748 0.206673,-0.35511 0.101157,-0.0919528 0.229335,-0.15226 0.369445,-0.167764 0.304996,-0.0341181 0.612673,-0.0512913 0.921315,-0.0599016 0.306665,-0.00855118 0.614587,-0.00855118 0.921799,-0.00837402 0.307256,-0.000177165 0.615197,-0.000177165 0.921823,0.00837402 0.308606,0.00861024 0.616193,0.0257835 0.921016,0.0599016 0.140244,0.0154961 0.268476,0.0757756 0.369728,0.167689 0.100626,0.0913504 0.174594,0.214075 0.207094,0.355185 0.0859488,0.37402 0.0859488,0.779492 0.0859409,1.16233l0.000208661 0 0 0.00967323 -0.000208661 0c1.5748e-005,0.192681 -7.48031e-005,0.391154 -0.0108425,0.586795 -0.0109134,0.19839 -0.0327126,0.395646 -0.0761575,0.584752zm-0.278929 0.2765c0.0849961,-0.0772126 0.147535,-0.180961 0.175181,-0.300248 0.0419449,-0.182579 0.0630433,-0.373945 0.0736535,-0.566839 0.0107638,-0.19563 0.0108543,-0.391161 0.0108425,-0.580961l-0.000208661 0 0 -0.00967323 0.000208661 0c3.93701e-006,-0.376594 7.87402e-006,-0.775457 -0.083437,-1.13858 -0.0274685,-0.119264 -0.0899803,-0.222992 -0.175016,-0.300185 -0.0849213,-0.0770866 -0.19235,-0.12763 -0.309728,-0.140602 -0.30328,-0.0339488 -0.607673,-0.0509882 -0.91226,-0.0594843 -0.306567,-0.00854724 -0.613094,-0.00854724 -0.918909,-0.00837402 -0.305772,-0.000173228 -0.61228,-0.000173228 -0.918886,0.00837402 -0.304618,0.00849606 -0.609102,0.0255394 -0.912559,0.0594843 -0.117224,0.0129724 -0.224587,0.0635433 -0.309445,0.140677 -0.0848898,0.0771614 -0.14728,0.180858 -0.174594,0.30011 -0.0421299,0.182626 -0.0634843,0.373984 -0.0743189,0.566902 -0.0107835,0.192075 -0.0110512,0.389496 -0.0110512,0.58135 0,0.191677 0,0.38913 0.0105118,0.580961 0.0105709,0.192882 0.0316654,0.384244 0.0738031,0.566839 0.0274724,0.119291 0.0899055,0.22302 0.174815,0.300201 0.0847992,0.0770866 0.192043,0.127618 0.30922,0.140591 0.303492,0.0339449 0.607976,0.0509843 0.912598,0.0594764 0.306602,0.00854724 0.61311,0.00854724 0.918925,0.00837402 0.305953,0.000173228 0.612457,0.000173228 0.919016,-0.00837402 0.304579,-0.00849213 0.608972,-0.0255354 0.912429,-0.0594764 0.117157,-0.0129724 0.224382,-0.0634882 0.309209,-0.140543z'/%3E%3C/svg%3E");
                background-size: contain;
                opacity: 0.5;
                will-change: opacity;
                transition: opacity 250ms ease-in-out;
                &:hover {
                  opacity: 1;
                }
              }
              .title {
                @include pubTitle;
                margin-bottom: 0.5rem;
              }
              .description {
                text-align: left;
                font-size: 0.9rem;
              }
              .source {
                position: absolute;
                left: 0.5rem;
                bottom: 0.5rem;
                height: 2rem;
                width: 2rem;
                background: no-repeat center;
                background-size: contain;
              }
              .date {
                position: absolute;
                bottom: 0.5rem;
                right: 0.5rem;
              }
              .duration {
                position: absolute;
                bottom: 0.5rem;
                left: 3rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.engage-wrap {
  .engage {
    .banner {
      .viewer {
        overflow: hidden;
        overflow-y: auto;
        height: calc(100vh - 5.25rem);
        padding-right: 1rem;
        .single {
          height: 100%;
          overflow: visible;
          overflow-y: auto;
          transform: scale(0.98);
          transform-origin: top center;
          .pdf-cards {
            height: 180vh;
          }
        }
      }
      .viewer {
        .single {
          //overflow: hidden;
          //transform: scale(0.98);
          //transform-origin: top center;
        }
      }
    }
  }
}
</style>
